webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_home_Home__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_home_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__containers_home_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_document_Document__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_document_Document___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__containers_document_Document__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_document_pages__ = __webpack_require__(7);



// Pages



// Document


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',

  // Reset scroll position to top when route change
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },


  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_home_Home___default.a
  }, {
    path: '/document',
    name: 'Document',
    component: __WEBPACK_IMPORTED_MODULE_3__containers_document_Document___default.a,
    children: [{
      path: 'introduction',
      name: 'Introduction',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["a" /* Introduction */]
    }, {
      path: 'installation',
      name: 'Installation',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["b" /* Installation */]
    }, {
      path: 'getting-start',
      name: 'GettingStart',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["c" /* GettingStart */]
    },

    // Component
    {
      path: 'component/accordion',
      name: 'ComponentAccordion',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["d" /* ComponentAccordion */]
    }, {
      path: 'component/breadcrumb',
      name: 'ComponentBreadcrumb',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["e" /* ComponentBreadcrumb */]
    }, {
      path: 'component/button',
      name: 'ComponentButton',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["f" /* ComponentButton */]
    }, {
      path: 'component/card',
      name: 'ComponentCard',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["g" /* ComponentCard */]
    }, {
      path: 'component/input',
      name: 'ComponentForm',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["h" /* ComponentForm */]
    }, {
      path: 'component/message',
      name: 'ComponentMessage',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["i" /* ComponentMessage */]
    }, {
      path: 'component/progress',
      name: 'ComponentProgress',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["j" /* ComponentProgress */]
    }, {
      path: 'component/tooltip',
      name: 'ComponentTooltip',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["k" /* ComponentTooltip */]
    },

    // Layout
    {
      path: 'layout/container',
      name: 'LayoutContainer',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["l" /* LayoutContainer */]
    }, {
      path: 'layout/responsive-grid',
      name: 'LayoutResponsiveGrid',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["m" /* LayoutResponsiveGrid */]
    },

    // Atomic
    {
      path: 'atomic/alignment',
      name: 'AtomicAlignment',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["n" /* AtomicAlignment */]
    }, {
      path: 'atomic/background',
      name: 'AtomicBackground',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["o" /* AtomicBackground */]
    }, {
      path: 'atomic/border',
      name: 'AtomicBorder',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["p" /* AtomicBorder */]
    }, {
      path: 'atomic/box-position',
      name: 'AtomicBoxPosition',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["q" /* AtomicBoxPosition */]
    }, {
      path: 'atomic/box-size',
      name: 'AtomicBoxSize',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["r" /* AtomicBoxSize */]
    }, {
      path: 'atomic/color',
      name: 'AtomicColor',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["s" /* AtomicColor */]
    }, {
      path: 'atomic/cursor',
      name: 'AtomicCursor',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["t" /* AtomicCursor */]
    }, {
      path: 'atomic/display',
      name: 'AtomicDisplay',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["u" /* AtomicDisplay */]
    }, {
      path: 'atomic/float',
      name: 'AtomicFloat',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["v" /* AtomicFloat */]
    }, {
      path: 'atomic/margin',
      name: 'AtomicMargin',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["w" /* AtomicMargin */]
    }, {
      path: 'atomic/object-fit',
      name: 'AtomicObjectFit',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["x" /* AtomicObjectFit */]
    }, {
      path: 'atomic/opacity',
      name: 'AtomicOpacity',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["y" /* AtomicOpacity */]
    }, {
      path: 'atomic/overflow',
      name: 'AtomicOverflow',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["z" /* AtomicOverflow */]
    }, {
      path: 'atomic/padding',
      name: 'AtomicPadding',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["A" /* AtomicPadding */]
    }, {
      path: 'atomic/typography',
      name: 'AtomicTypography',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["B" /* AtomicTypography */]
    }, {
      path: 'atomic/z-index',
      name: 'AtomicZIndex',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["C" /* AtomicZIndex */]
    },

    // Utility
    {
      path: 'utility/animation',
      name: 'UtilityAnimation',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["D" /* UtilityAnimation */]
    }, {
      path: 'utility/rise',
      name: 'UtilityRise',
      component: __WEBPACK_IMPORTED_MODULE_4__components_document_pages__["E" /* UtilityRise */]
    }]
  }]
}));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(52)
  __webpack_require__(53)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(125),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TheFooter__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TheFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TheFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TheNavbar__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TheNavbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TheNavbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__TheFooter___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__TheNavbar___default.a; });





/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Introduction__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Introduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Introduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Installation__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Installation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Installation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GettingStart__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GettingStart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__GettingStart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ComponentAccordion__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ComponentAccordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ComponentAccordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ComponentBreadcrumb__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ComponentBreadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ComponentBreadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ComponentButton__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ComponentButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ComponentButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ComponentCard__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ComponentCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ComponentCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ComponentForm__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ComponentForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ComponentForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ComponentMessage__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ComponentMessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ComponentMessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ComponentProgress__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ComponentProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ComponentProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ComponentTooltip__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ComponentTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ComponentTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LayoutContainer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LayoutContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__LayoutContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__LayoutResponsiveGrid__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__LayoutResponsiveGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__LayoutResponsiveGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AtomicAlignment__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AtomicAlignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__AtomicAlignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AtomicBackground__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AtomicBackground___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__AtomicBackground__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AtomicBorder__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AtomicBorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__AtomicBorder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AtomicBoxPosition__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AtomicBoxPosition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__AtomicBoxPosition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AtomicBoxSize__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AtomicBoxSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__AtomicBoxSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AtomicColor__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AtomicColor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__AtomicColor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AtomicCursor__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AtomicCursor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__AtomicCursor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__AtomicDisplay__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__AtomicDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__AtomicDisplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__AtomicFloat__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__AtomicFloat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__AtomicFloat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__AtomicMargin__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__AtomicMargin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__AtomicMargin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__AtomicObjectFit__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__AtomicObjectFit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__AtomicObjectFit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__AtomicOpacity__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__AtomicOpacity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__AtomicOpacity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__AtomicOverflow__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__AtomicOverflow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__AtomicOverflow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__AtomicPadding__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__AtomicPadding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__AtomicPadding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__AtomicTypography__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__AtomicTypography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__AtomicTypography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__AtomicZIndex__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__AtomicZIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__AtomicZIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__UtilityAnimation__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__UtilityAnimation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__UtilityAnimation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__UtilityRise__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__UtilityRise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__UtilityRise__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Introduction___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Installation___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__GettingStart___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__ComponentAccordion___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__ComponentBreadcrumb___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__ComponentButton___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__ComponentCard___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__ComponentForm___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__ComponentMessage___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__ComponentProgress___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__ComponentTooltip___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__LayoutContainer___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__LayoutResponsiveGrid___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__AtomicAlignment___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14__AtomicBackground___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15__AtomicBorder___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_16__AtomicBoxPosition___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_17__AtomicBoxSize___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_18__AtomicColor___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_19__AtomicCursor___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_20__AtomicDisplay___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_21__AtomicFloat___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_22__AtomicMargin___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_23__AtomicObjectFit___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_24__AtomicOpacity___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_25__AtomicOverflow___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_26__AtomicPadding___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_27__AtomicTypography___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_28__AtomicZIndex___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_29__UtilityAnimation___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_30__UtilityRise___default.a; });






































/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(4);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// router.beforeEach((to, from, next) => {
//   window.scrollTo(0, 0)
//   console.log('%%%')
//   next()
// })

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',

  components: {
    TheNavbar: __WEBPACK_IMPORTED_MODULE_0__components_common__["a" /* TheNavbar */],
    TheFooter: __WEBPACK_IMPORTED_MODULE_0__components_common__["b" /* TheFooter */]
  },

  data: function data() {
    return {
      isNavbarColor: false,
      isShowNavbar: true,
      isShowFooter: true
    };
  },


  watch: {
    $route: function $route() {
      this.initialNavbar();
      this.initialFooter();
    }
  },

  mounted: function mounted() {
    this.initialNavbar();
    this.initialFooter();
  },


  methods: {
    initialNavbar: function initialNavbar() {
      window.removeEventListener('scroll', this.checkNavbarColor);
      if (this.isDocumentPage()) {
        this.isNavbarColor = true;
      } else {
        this.checkNavbarColor();
        window.addEventListener('scroll', this.checkNavbarColor);
      }
    },
    initialFooter: function initialFooter() {
      this.isDocumentPage() ? this.footerHide() : this.footerShow();
    },
    checkNavbarColor: function checkNavbarColor() {
      this.isNavbarColor = window.scrollY > 15;
    },
    getFooterHeight: function getFooterHeight() {
      if (this.$refs.TheFooter) {
        return this.$refs.TheFooter.$el.clientHeight;
      }
    },
    isDocumentPage: function isDocumentPage() {
      return this.$route.matched.filter(function (x) {
        return x.name === 'Document';
      }).length === 1;
    },
    navbarShow: function navbarShow() {
      this.isShowNavbar = true;
    },
    navbarHide: function navbarHide() {
      this.isShowNavbar = false;
    },
    footerShow: function footerShow() {
      this.isShowFooter = true;
    },
    footerHide: function footerHide() {
      this.isShowFooter = false;
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TheFooter'
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TheNavbar',

  props: {
    isColor: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      isMenuOpen: false
    };
  },


  watch: {
    '$route': function $route() {
      this.menuClose();
    }
  },

  methods: {
    menuOpen: function menuOpen() {
      this.isMenuOpen = true;
    },
    menuClose: function menuClose() {
      this.isMenuOpen = false;
    },
    menuToggle: function menuToggle() {
      this.isMenuOpen = !this.isMenuOpen;
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicAlignment',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicBackground',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicBorder',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicBoxPosition',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicBoxSize',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicColor',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicCursor',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicDisplay',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicFloat',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicMargin',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicObjectFit',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicOpacity',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicOverflow',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicMargin',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicTypography',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomicZIndex',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ComponentAccordion',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ComponentBreadcrumb',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ComponentButton',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ComponentCard',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ComponentForm',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ComponentMessage',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ComponentProgress',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ComponentTooltip',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GettingStart',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Installation',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Introduction',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LayoutContainer',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LayoutResponsiveGrid',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UtilityAnimation',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UtilityAnimation',

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Document'
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HomeBanner__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HomeBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__HomeBanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HomeBenefits__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HomeBenefits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__HomeBenefits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HomeGettingStart__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HomeGettingStart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__HomeGettingStart__);
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home',

  components: {
    HomeBanner: __WEBPACK_IMPORTED_MODULE_0__HomeBanner___default.a,
    HomeBenefits: __WEBPACK_IMPORTED_MODULE_1__HomeBenefits___default.a,
    HomeGettingStart: __WEBPACK_IMPORTED_MODULE_2__HomeGettingStart___default.a
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HomeBanner'
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HomeBenefits'
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HomeGettingStartSetup__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HomeGettingStartSetup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__HomeGettingStartSetup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HomeGettingStartBasic__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HomeGettingStartBasic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__HomeGettingStartBasic__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HomeGettingStart',

  components: {
    HomeGettingStartSetup: __WEBPACK_IMPORTED_MODULE_1__HomeGettingStartSetup___default.a,
    HomeGettingStartBasic: __WEBPACK_IMPORTED_MODULE_2__HomeGettingStartBasic___default.a
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlightAll();
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HomeGettingStartBasic'
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HomeGettingStartSetup'
});

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(57)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(141),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-91b32072",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(56)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(133),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55d893bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(140),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(50)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(110),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0386a932",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(143),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(119),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(112),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(130),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(51)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(111),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13aca3bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(122),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(121),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(146),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(113),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(134),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(127),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(136),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(118),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(107),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(116),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(142),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(109),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(139),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(137),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(54)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(128),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4c911ec8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(124),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(55)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(131),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5257a730",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(145),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(58)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(144),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-be5cbe8c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(115),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_vm._v("\n      การใช้งาน Biomatic\n    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "getting-start-atomic"
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      Atomic Class คือหัวใจหลักของ Biomatic เปรียบเสมือนกล่องเครื่องมือที่คุณใช้งานบ่อย เป็น Class ที่ใช้กำหนด Style เพียงอย่างใดอย่างหนึ่ง\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n      คุณสามารถใช้ Atomic Class หลายๆ Class ประกอบกันเพื่อเป็นผลลัพธ์ที่คุณต้องการได้\n      หรือใช้งานร่วมกับ Class อื่นๆ เพื่อปรับแต่งการแสดงผลให้เป็นไปตามที่คุณต้องการ 😲\n    ")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      ปัญหาของ Atomic Framework โดยทั่วไปคือชื่อ Class นั้นหลายครั้งไม่มีรูปแบบชัดเจนและคาดเดาได้ยาก เนื่องจาก\n      ความพยายามในการตั้งให้มีความสั้นเกินไป หรือยาวเกินไป 😅\n    ")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n      Value ก็ใช้กฏแบบเดียวกัน (ยกเว้นค่าคงที่ของ Biomatic เช่น Color Name)\n    ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n      ตัวอย่าง\n    ")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('p', {
    staticClass: "_fs-4 _fw-600 _lh-150pct _mgbt-16px"
  }, [_vm._v("\n      Responsive ใน Atomic Class\n    ")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('p', {
    staticClass: "_fs-4 _fw-600 _lh-150pct _mgbt-16px"
  }, [_vm._v("\n      Hover ใน Atomic Class\n    ")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "getting-start-component"
    }
  }), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Component Class")]), _vm._v(" ใช้เพื่อแสดงผล Elements พื้นฐาน เช่น\n      "), _c('router-link', {
    staticClass: "bio-link",
    attrs: {
      "to": {
        name: 'ComponentButton'
      }
    }
  }, [_vm._v("Button")]), _vm._v(",\n      "), _c('router-link', {
    staticClass: "bio-link",
    attrs: {
      "to": {
        name: 'ComponentLink'
      }
    }
  }, [_vm._v("Link")]), _vm._v(",\n      "), _c('router-link', {
    staticClass: "bio-link",
    attrs: {
      "to": {
        name: 'ComponentCard'
      }
    }
  }, [_vm._v("Card")]), _vm._v(" หรือ\n      "), _c('router-link', {
    staticClass: "bio-link",
    attrs: {
      "to": {
        name: 'ComponentForm'
      }
    }
  }, [_vm._v("Form")])], 1), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      Component Class สามารถใช้ Options เพื่อเปลี่ยนรูปแบบการแสดงผลของ Style, Color หรือ State ได้\n    ")]), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "getting-start-layout"
    }
  }), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      Responsive Grid Layout เป็นเทคนิคพื้นฐานที่ใช้จัดการ Layout สำหรับหลายขนาดหน้าจอ\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      Biomatic จะมีการใช้งาน Responsive Grid ที่แตกต่างกับ Framework อื่นๆ\n      คือ เราจะกำหนด Layout ที่ Container เพียงอย่างเดียวเท่านั้น 🤔\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      สาเหตุที่เรากำหนด Layout ที่ Container ก็เพราะว่าเราจะลด Element ด้านในที่ไม่จำเป็นออกไป\n      ให้ DOM มีความซับซ้อนน้อยที่สุด และเพื่อแยก Element ที่ทำหน้าที่เป็น Layout และ Component อย่างชัดเจน\n    ")]), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-48px _fs-5"
  }, [_vm._v("\n      นอกจากนี้ Layout Class ยังสามารถกำหนด Option เพื่อกำหนดรายละเอียดต่างๆ เช่น Grid Gutter ได้อีกด้วย 😍\n    ")]), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "getting-start-utility"
    }
  }), _vm._v(" "), _vm._m(45), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      Utility Class ใช้สำหรับกำหนดลักษณะต่างๆ ที่ Biomatic เตรียมไว้ เช่น Animation, Hover behavior\n      โดยสามารถร่วมกับ Class อื่นๆ ได้ทั่วไป\n    ")]), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _vm._m(48), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'Installation'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  วิธีติดตั้ง\n        ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicAlignment'
      }
    }
  }, [_vm._v("\n          Alignment   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-64px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#getting-start"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" การใช้งาน\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n      Biomatic แบ่งการใช้งานเป็นดังต่อไปนี้ "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-128px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#getting-start-atomic"
    }
  }, [_vm._v("ใช้งาน Atomic Class")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#getting-start-component"
    }
  }, [_vm._v("ใช้งาน Component Class")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#getting-start-layout"
    }
  }, [_vm._v("ใช้งาน Layout Class")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#getting-start-utility"
    }
  }, [_vm._v("ใช้งาน Utility Class")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#getting-start-atomic"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" การใช้งาน Atomic Class ✨✨\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n      Atomic Class ใช้ Prefix "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_")]), _vm._v(" ตามด้วยชื่อ Class\n      ที่เป็นคู่ของ "), _c('strong', [_vm._v("Name")]), _vm._v(" และ "), _c('strong', [_vm._v("Value")]), _vm._v(" เช่น\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_mg-8px")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_pdt-16px")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_w-100pct")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n      สำหรับ Biomatic เราต้องการให้ผู้ใช้งานไม่จำเป็นต้องมีการจำชื่อ Class จึงกำรูปแบบการตั้งชื่อขึ้นมาคือ\n      "), _c('u', [_vm._v("ใช้ตัวย่อตามเสียงที่ออก")]), _vm._v(" เช่น "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('strong', [_vm._v("margin")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_mg")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("margin-button")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_mgbt")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("text-align")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_tal")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("position")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_pst")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('strong', [_vm._v("16 pixel")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("16px")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("100 percentage")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("100pct")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("center")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("ct")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("inline-block")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("ilb")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("auto")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("at")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('strong', [_vm._v("padding-top: 64px")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_pdt-64px")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("width: 100%")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_w-100pct")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("cursor: pointer")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_cs-pt")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("display: inline-block")]), _vm._v(" จะเป็น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("_dp-ilb")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-48px _fs-5"
  }, [_vm._v("\n      จนถึงตรงนี้คุณน่าจะเข้าใจแนวคิด และรู้ว่า Atomic Class\n      ที่คุณจะใช้ควรมีหน้าตาแบบไหนโดยไม่ต้องอ่าน Document\n      (คุณลองเดาชื่อ Atomic Class ของ\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("float: left")]), _vm._v(" หรือ "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("position: absolute")]), _vm._v(" ดูสิ! 😄)\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Atomic Class")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!--\ntext-align: center,\npadding: 16px,\ncolor: white (เป็นค่าคงที่ของ Biomatic),\nbackground-color: primary (เป็นค่าคงที่ของ Biomatic),\nborder-radius: 4px,\nfont-size: 4 (เป็นค่าคงที่ของ Biomatic)\n-->\n<div class=\"_tal-ct _pd-16px _fs-4 _cl-white _bgcl-primary _bdrd-4px\">\n  Content\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px _pd-8px"
  }, [_c('div', {
    staticClass: "_tal-ct _pd-16px _fs-4 _cl-white _bgcl-primary _bdrd-4px"
  }, [_vm._v("Content")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-48px _fs-5"
  }, [_vm._v("\n      Atomic Class สามารถใช้งาน Breakpoint\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-sm")]), _vm._v(" "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-md")]), _vm._v(" "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-lg")]), _vm._v("\n      ที่ Class เพื่อให้แสดงผลที่ขนาดหน้าจอใดๆ ขึ้นไป ในการทำ Responsive Style ได้ 😄\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Breakoint ใน Atomic Class")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!--\nContainer\ntext-align: center,\ntext-align: left when small size screen,\ntext-align: right when medium size screen,\n\nBox\ndisplay: inine-block,\nwidth: 32px,\nheight: 32px,\nbackground-color: negative (เป็นค่าคงที่ของ Biomatic),\nbackground-color: positive (เป็นค่าคงที่ของ Biomatic) when small size screen,\n-->\n<div class=\"_tal-ct _tal-l-sm _tal-r-md\">\n  <div class=\"_dp-ilb _w-32px _h-32px _bgcl-negative _bgcl-positive-sm\"></div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px _pd-8px"
  }, [_c('div', {
    staticClass: "_tal-ct _tal-l-sm _tal-r-md"
  }, [_c('div', {
    staticClass: "_dp-ilb _w-32px _h-32px _bgcl-negative _bgcl-positive-sm"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-48px _fs-5"
  }, [_vm._v("\n      Atomic Class ที่เกี่ยวกับ Color ได้แก่ Color, Background Color และ Border Color จะสามารถใส่\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-hover")]), _vm._v("\n      ที่ Class เพื่อให้แสดงผลที่ Class เมื่อ Hover State ได้ 😄\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Hover ใน Atomic Class")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"_h-32px _bgcl-positive _bgcl-negative-hover _cl-white _cl-black-hover\">\n  <strong>Hello</strong>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel  _mgbt-128px _pd-8px"
  }, [_c('div', {
    staticClass: "_h-32px _bgcl-positive _bgcl-negative-hover _cl-white _cl-black-hover"
  }, [_c('strong', [_vm._v("Hello")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#getting-start-component"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" ใช้งาน Component Class ✨✨\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n      Component Class ใช้ Prefix "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("bio-")]), _vm._v(" ตามด้วย Value เป็นชื่อ Component เช่น\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("bio-button")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("bio-link")]), _vm._v(" หรือ\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("bio-accordion")]), _vm._v(" เป็นต้น\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-48px _fs-5"
  }, [_vm._v("\n      Option Class จะใช้ Prefix "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-")]), _vm._v(" ตามด้วยชื่อ Option เช่น\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-disabled")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-fancy")]), _vm._v(" หรือ\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-loading")]), _vm._v(" เป็นต้น 😲\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน bio-button รูปแบบต่างๆ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-button\"></div>\n<div class=\"bio-button -positive\"></div>\n<div class=\"bio-button -negative\"></div>\n<div class=\"bio-button -negative -outline\"></div>\n<div class=\"bio-button -loading\"></div>\n<div class=\"bio-button -disabled\"></div>\n<div class=\"bio-button -negative -disabled -loading\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_mgbt-48px u-panel"
  }, [_c('div', {
    staticClass: "bio-button _dp-ilb _mgbt-4px"
  }, [_vm._v("bio-button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive _dp-ilb _mgbt-4px"
  }, [_vm._v("bio-button -positive")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative _dp-ilb _mgbt-4px"
  }, [_vm._v("bio-button -negative")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -outline _dp-ilb _mgbt-4px"
  }, [_vm._v("bio-button -negative -outline")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -loading _dp-ilb _mgbt-4px"
  }, [_vm._v("bio-button -loading")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -disabled _dp-ilb _mgbt-4px"
  }, [_vm._v("bio-button -disabled")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -disabled -loading _dp-ilb _mgbt-4px"
  }, [_vm._v("bio-button -negative -disabled -loading")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n      จะสังเกตว่ารูปแบบการเขียนลักษณะนี้ จะหมือนกับ Switched ใน UNIX commandline เช่น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("ls -a")]), _vm._v(" เป็นต้น 🤔\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -primary _fs-6 _mgbt-128px"
  }, [_c('p', [_c('strong', [_vm._v("คำแนะนำ")]), _vm._v(" – คุณ"), _c('u', [_vm._v("ไม่")]), _vm._v("ควรใส่ Component Class มากกว่าหนึ่ง Class\n        ที่ Element เดียวกัน เพราะ Element แต่ละอันควรทำหน้าที่เพียงอย่างเดียวเท่านั้น\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#getting-start-layout"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" การใช้งาน Layout Class ✨✨\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-48px _fs-5"
  }, [_vm._v("\n      Layout ที่ซับซ้อนมากๆ ถ้าใช้การกำหนด Layout แบบทั่วไปคุณจะพบว่า DOM\n      จะมีระดับชั้นของ Nested "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("<div>")]), _vm._v("\n      ที่ใช้เพียงเพื่อสร้าง Layout ที่ลึกมาก หรือที่เรียกว่า \"divitis\" 😱\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างของ \"Divitis\"")]), _vm._v(" 🙅🙅🙅\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "_mgbt-48px"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class='image'>\n  <div class='shadow'>\n    <div class='bottom-shadow'>\n      <div class='content'>\n        <img src=\"...\" alt=\"\" />\n      </div>\n    </div>\n  </div>\n  <div class=\"actions\">\n    <div class=\"action item\">\n      <div class=\"button-container\">\n        <div class=\"button\">\n          Click Me\n        </div>\n      </div>\n    </div>\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -primary _mgbt-48px"
  }, [_c('p', {
    staticClass: "_fs-6"
  }, [_c('strong', [_vm._v("คำแนะนำ")]), _vm._v(" – Biomatic แนะนำให้คุณใช้ "), _c('a', {
    staticClass: "bio-link -fancy",
    attrs: {
      "href": "http://learncssgrid.com/",
      "target": "_blank"
    }
  }, [_vm._v("CSS Grid")]), _vm._v(" สำหรับ Layout ที่มีซับซ้อน 👍 "), _c('br'), _vm._v("\n        (ปัจจุบัน "), _c('a', {
    staticClass: "bio-link -fancy",
    attrs: {
      "href": "https://caniuse.com/#feat=css-grid",
      "target": "_blank"
    }
  }, [_vm._v("Support Modern Browser")]), _vm._v(" แล้ว)\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      Layout Class ใช้ Prefix "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-")]), _vm._v("\n      ตามด้วย Value เป็นขนาดของ Grid ที่ต้องการ\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      Biomatic ใช้ Grid 12 เป็น Grid Systems ซึ่งสามารถกำหนด Value เป็นค่าที่หาร 12 ลงตัว คือ\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-1")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-2")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-3")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-4")]), _vm._v(",\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-6")]), _vm._v(" และ\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-12")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n      หรือ คู่ของผลรวม ที่รวมกันได้ 12 เช่น\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-4-8")]), _vm._v(" หรือ\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("lo-9-3")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Layout Class")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"lo-4 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<div class=\"lo-8-4 -gapv-16px -gaph-4px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_mgbt-48px _pd-8px u-panel "
  }, [_c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-4")]), _vm._v(" "), _c('div', {
    staticClass: "lo-4 -gap-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gapv-16px -gaph-4px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n      Layout Class สามารถใส่ Breakpoint\n      "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-sm")]), _vm._v(" "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-md")]), _vm._v(" "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-lg")]), _vm._v("\n      ที่ Class เพื่อแสดงผลที่ขนาดหน้าจอใดๆ เพื่อใช้ในการทำ Responsive Grid\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -primary _fs-6 _mgbt-48px"
  }, [_c('p', [_c('strong', [_vm._v("คำแนะนำ")]), _vm._v(" – Biomatic ไม่มี Breakpoint "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("-xs")]), _vm._v("\n        เพราะเรายึดหลักแนวคิดของ Progressive Enhancement หรือ Mobile First นั่นคือเรากำหนด Interface ของ\n        Mobile เป็นพื้นฐานก่อน และตามด้วย Interface ที่ขนาดหน้าจอที่ใหญ่ขึ้น 😤\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Breakpoint ใน Layout Class")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"lo-12 lo-9-3-sm lo-3-lg -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_mgbt-128px _pd-8px u-panel "
  }, [_c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v("lo-12 lo-9-3-sm lo-3-lg")]), _vm._v(" "), _c('div', {
    staticClass: "lo-12 lo-9-3-sm lo-3-lg -gap-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral _bdrd-2px _tal-ct _pd-4px"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#getting-start-utility"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" การใช้งาน Utility Class ✨✨\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n      ใช้ Prefix "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("u-")]), _vm._v(" แล้วตามด้วย Value เป็นชื่อ Utility ของ Biomatic\n      เช่น "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("u-animation-pulse")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v("u-rise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-button u-animation-pulse\">bio-button u-animation-pulse</div>\n<div class=\"bio-button u-rise\">bio-button u-rise</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_mgbt-48px _pd-8px u-panel"
  }, [_c('div', {
    staticClass: "bio-button _mgbt-24px u-animation-pulse"
  }, [_vm._v("bio-button u-animation-pulse")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button u-rise"
  }, [_vm._v("bio-button u-rise")])])
}]}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Button ใช้สำหรับแสดงผลปุ่มลักษณะต่างๆ\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentBreadcrumb'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Breadcrumb\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentCard'
      }
    }
  }, [_vm._v("\n            Card   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-button"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Button\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-button")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-button")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Color: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-primary")]), _vm._v(" (default),\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-accent")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-positive")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-negative")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-warning")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-info")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-white")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gray")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-dark")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-black")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("State: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-loading")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-disabled")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Style: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-outline")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-button\">.bio-button</div>\n<div class=\"bio-button -accent\">bio-button -accent</div>\n<div class=\"bio-button -positive\">bio-button -positive</div>\n<div class=\"bio-button -negative\">bio-button -negative</div>\n<div class=\"bio-button -info\">bio-button -info</div>\n<div class=\"bio-button -warning\">bio-button -warning</div>\n<div class=\"bio-button -white\">bio-button -white</div>\n<div class=\"bio-button -gray\">bio-button -gray</div>\n<div class=\"bio-button -dark\">bio-button -dark</div>\n<div class=\"bio-button -black\">bio-button -black</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-button _dp-ilb _mgbt-8px"
  }, [_vm._v(".bio-button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -accent _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -accent")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -positive")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -negative")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -info _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -info")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -warning _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -warning")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -white _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -white")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -gray _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -gray")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -dark _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -dark")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -black _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -black")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน อื่นๆ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-button\">.bio-button</div>\n<div class=\"bio-button -accent\">bio-button -accent</div>\n<div class=\"bio-button -positive\">bio-button -positive</div>\n<div class=\"bio-button -negative\">bio-button -negative</div>\n<div class=\"bio-button -info\">bio-button -info</div>\n<div class=\"bio-button -warning\">bio-button -warning</div>\n<div class=\"bio-button -white\">bio-button -white</div>\n<div class=\"bio-button -gray\">bio-button -gray</div>\n<div class=\"bio-button -dark\">bio-button -dark</div>\n<div class=\"bio-button -black\">bio-button -black</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-button -outline _dp-ilb _mgbt-8px"
  }, [_vm._v(".bio-button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -accent -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -accent")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -positive")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -negative")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -info -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -info")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -warning -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -warning")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -white -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -white")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -gray -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -gray")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -dark -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -dark")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -black -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("bio-button -black")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน อื่นๆ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-button -accent\">Hello Button</div>\n<div class=\"bio-button -positive -loading\">Hello Button</div>\n<div class=\"bio-button -positive -disabled\">Hello Button</div>\n<div class=\"bio-button -positive -loading -disabled\">Hello Button</div>\n<div class=\"bio-button -positive -outline\">Hello Button</div>\n<div class=\"bio-button -positive -outline -loading\">Hello Button</div>\n<div class=\"bio-button -positive -outline -disabled\">Hello Button</div>\n<div class=\"bio-button -positive -outline -loading -disabled\">Hello Button</div>\n\n<div class=\"bio-button -negative\">Hello Button</div>\n<div class=\"bio-button -negative -loading\">Hello Button</div>\n<div class=\"bio-button -negative -disabled\">Hello Button</div>\n<div class=\"bio-button -negative -loading -disabled\">Hello Button</div>\n<div class=\"bio-button -negative -outline\">Hello Button</div>\n<div class=\"bio-button -negative -outline -loading\">Hello Button</div>\n<div class=\"bio-button -negative -outline -disabled\">Hello Button</div>\n<div class=\"bio-button -negative -outline -loading -disabled\">Hello Button</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-button -positive _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -loading _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -disabled _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -loading -disabled _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -outline -loading _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -outline -disabled _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -outline -loading -disabled _dp-ilb _mgbt-32px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -loading _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -disabled _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -loading -disabled _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -outline _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -outline -loading _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -outline -disabled _dp-ilb _mgbt-8px"
  }, [_vm._v("Hello Button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -negative -outline -loading -disabled _dp-ilb _mgbt-32px"
  }, [_vm._v("Hello Button")])])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n    Biomatic ได้สร้าง Responsive Container ให้คุณได้ใช้งาน\n  ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentTooltip'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Tooltip\n      ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'LayoutResponsiveGrid'
      }
    }
  }, [_vm._v("\n        Responsive Grid   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#layout-container"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Container\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-container")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Option:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-container")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n            -\n          ")])])])])])
}]}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ Background ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-background-color"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้กำหนดสีของ Background ให้กับ Element\n      ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-background-size"
    }
  }), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้กำหนดรูปแบบการ Fill ของ Background Image\n      ")]), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-background-repeat"
    }
  }), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้กำหนดรูปแบบการ Repeat ของ Background Image\n      ")]), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-background-position"
    }
  }), _vm._v(" "), _vm._m(45), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้กำหนดตำแหน่งการจัดวางของ Background\n      ")]), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicAlignment'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("   Alignment\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBorder'
      }
    }
  }, [_vm._v("\n            Border   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-border"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Background\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-128px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-background-color"
    }
  }, [_vm._v("Background Color")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-background-size"
    }
  }, [_vm._v("Background Size")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-background-repeat"
    }
  }, [_vm._v("Background Repeat")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-background-position"
    }
  }, [_vm._v("Background Position")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-background-color"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Background Color\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgcl-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("background-color")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgcl-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Biomatic's Color Name Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("primary[-{100-900}]")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("accent[-{100-900}]")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("neutral[-{100-900}]")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("positive")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("negative")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("warning")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("white")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("gray")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("dark")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("black")])]), _vm._v(" "), _c('p')])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-hover")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Background Color – Branding Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Primary Color -->\n<div>\n  <div class=\"_bgcl-primary\">primary</div>\n  <div class=\"_bgcl-primary-100\">primary-100</div>\n  <div class=\"_bgcl-primary-200\">primary-200</div>\n  <div class=\"_bgcl-primary-300\">primary-300</div>\n  <div class=\"_bgcl-primary-400\">primary-400</div>\n  <div class=\"_bgcl-primary-500\">primary-500</div>\n  <div class=\"_bgcl-primary-600\">primary-600</div>\n  <div class=\"_bgcl-primary-700\">primary-700</div>\n  <div class=\"_bgcl-primary-800\">primary-800</div>\n  <div class=\"_bgcl-primary-900\">primary-900</div>\n</div>\n\n<!-- Accent Color -->\n<div>\n  <div class=\"_bgcl-accent\">accent</div>\n  <div class=\"_bgcl-accent-100\">accent-100</div>\n  <div class=\"_bgcl-accent-200\">accent-200</div>\n  <div class=\"_bgcl-accent-300\">accent-300</div>\n  <div class=\"_bgcl-accent-400\">accent-400</div>\n  <div class=\"_bgcl-accent-500\">accent-500</div>\n  <div class=\"_bgcl-accent-600\">accent-600</div>\n  <div class=\"_bgcl-accent-700\">accent-700</div>\n  <div class=\"_bgcl-accent-800\">accent-800</div>\n  <div class=\"_bgcl-accent-900\">accent-900</div>\n</div>\n\n<!-- Neutral Color -->\n<div>\n  <div class=\"_bgcl-neutral\">neutral</div>\n  <div class=\"_bgcl-neutral-100\">neutral-100</div>\n  <div class=\"_bgcl-neutral-200\">neutral-200</div>\n  <div class=\"_bgcl-neutral-300\">neutral-300</div>\n  <div class=\"_bgcl-neutral-400\">neutral-400</div>\n  <div class=\"_bgcl-neutral-500\">neutral-500</div>\n  <div class=\"_bgcl-neutral-600\">neutral-600</div>\n  <div class=\"_bgcl-neutral-700\">neutral-700</div>\n  <div class=\"_bgcl-neutral-800\">neutral-800</div>\n  <div class=\"_bgcl-neutral-900\">neutral-900</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "lo-12 lo-4-sm -gap-16px"
  }, [_c('div', [_c('div', {
    staticClass: "_bgcl-primary _cl-white _h-128px _bdtrrd-3px _bdtlrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("primary")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-100 _cl-neutral-800 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-100")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-200 _cl-neutral-800 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-200")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-300 _cl-neutral-900 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-300")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-400 _cl-neutral-900 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-400")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-500 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-500")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-600 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-600")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-700 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-700")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-800 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-800")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-900 _cl-white _pd-12px _bdbtrrd-3px _bdbtlrd-3px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-900")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "_bgcl-accent _cl-white _h-128px _bdtrrd-3px _bdtlrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("accent")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-100 _cl-neutral-800 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-100")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-200 _cl-neutral-800 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-200")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-300 _cl-neutral-900 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-300")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-400 _cl-neutral-900 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-400")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-500 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-500")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-600 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-600")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-700 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-700")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-800 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-800")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-900 _cl-white _pd-12px _bdbtrrd-3px _bdbtlrd-3px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-900")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "_bgcl-neutral _cl-white _h-128px _bdtrrd-3px _bdtlrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("neutral")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-100 _cl-neutral-800 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-100")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-200 _cl-neutral-800 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-200")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _cl-neutral-900 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-300")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _cl-neutral-900 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-400")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-500 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-500")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-600 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-600")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-700 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-700")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-800 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-800")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-900 _cl-white _pd-12px _bdbtrrd-3px _bdbtlrd-3px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-900")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Background Color – Semantic Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Semantic Color -->\n<div class=\"_bgcl-positive\">positive</div>\n<div class=\"_bgcl-negative\">negative</div>\n<div class=\"_bgcl-warning\">warning</div>\n<div class=\"_bgcl-info\">info</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "lo-12 lo-4-sm -gap-16px"
  }, [_c('div', {
    staticClass: "_bgcl-positive _cl-white _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("positive")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-negative _cl-white _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("negative")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-warning _cl-white _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("warning")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-info _cl-white _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("info")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Background Color – Grayscale Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Grayscale Color -->\n<div class=\"_bgcl-positive\">positive</div>\n<div class=\"_bgcl-negative\">negative</div>\n<div class=\"_bgcl-warning\">warning</div>\n<div class=\"_bgcl-info\">info</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "lo-12 lo-4-sm -gap-16px"
  }, [_c('div', {
    staticClass: "_bgcl-white _cl-neutral-700 _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("white")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-gray _cl-neutral-700 _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("gray")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-dark _cl-white _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("dark")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-black _cl-white _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("black")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Background Color – Hover")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"_bgcl-positive _bgcl-negative-hover\">Hover Me</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "lo-12 lo-4-sm -gap-16px"
  }, [_c('div', {
    staticClass: "_bgcl-positive _bgcl-negative-hover _cl-white _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("Hover Me")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-background-size"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Background Size\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgs-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("background-size")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgs-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("cv")]), _vm._v(" สำหรับ \"cover\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("ct")]), _vm._v(" สำหรับ \"contain\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Background Size")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"\"></div>\n<div class=\"_bgs-ct\"></div>\n<div class=\"_bgs-cv\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "_mgbt-32px"
  }, [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Original Image")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://placeimg.com/200/200/animals",
      "alt": "image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lo-12 lo-4-sm -gap-16px"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Default")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Contain")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image _bgs-ct"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image _bgs-cv"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-background-repeat"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Background Repeat\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgrp-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("background-repeat")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgrp-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("rp")]), _vm._v(" สำหรับ \"repeat\" "), _c('small', {
    staticClass: "_opct-50"
  }, [_vm._v("(default)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("rpx")]), _vm._v(" สำหรับ \"repeat-x\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("rpy")]), _vm._v(" สำหรับ \"repeat-y\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("nrp")]), _vm._v(" สำหรับ \"no-repeat\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("sp")]), _vm._v(" สำหรับ \"space\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("r")]), _vm._v(" สำหรับ \"round\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Background Repeat")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"_bgrp-rp\"></div>\n<div class=\"_bgrp-rpx\"></div>\n<div class=\"_bgrp-rpy\"></div>\n<div class=\"_bgrp-nrp\"></div>\n<div class=\"_bgrp-sp\"></div>\n<div class=\"_bgrp-r\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "_mgbt-32px"
  }, [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Original Image")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://placeimg.com/40/40/animals",
      "alt": "image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lo-12 lo-4-sm -gap-16px"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Default/ Repeat")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Repeat X")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-rpx"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Repeat Y")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-rpy"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("No Repeat")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Space")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-sp"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Round")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-r"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-background-position"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Background Position\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgpst-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("background-position")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgpst-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("t")]), _vm._v(" สำหรับ \"top\" "), _c('small', {
    staticClass: "_opct-50"
  }, [_vm._v("(default)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("tr")]), _vm._v(" สำหรับ \"top right\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("tl")]), _vm._v(" สำหรับ \"top left\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("bt")]), _vm._v(" สำหรับ \"bottom\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("btr")]), _vm._v(" สำหรับ \"bottom right\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("btl")]), _vm._v(" สำหรับ \"bottom left\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("ct")]), _vm._v(" สำหรับ \"center\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("ctr")]), _vm._v(" สำหรับ \"center right\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("ctl")]), _vm._v(" สำหรับ \"center left\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Background Repeat")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"_bgpst-tl\"></div>\n<div class=\"_bgpst-t\"></div>\n<div class=\"_bgpst-tr\"></div>\n<div class=\"_bgpst-ctl\"></div>\n<div class=\"_bgpst-ct\"></div>\n<div class=\"_bgpst-ctr\"></div>\n<div class=\"_bgpst-btl\"></div>\n<div class=\"_bgpst-bt\"></div>\n<div class=\"_bgpst-btr\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "lo-12 lo-4-sm -gap-16px"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Top Left")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-tl"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Top")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-t"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Top Right")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-tr"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Center Left")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-ctl"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Center")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-ct"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Center Right")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-ctr"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Bottom Left")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-btl"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Bottom")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-bt"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Bottom Right")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-btr"
  })])])])
}]}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ Opacity ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicObjectFit'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Object Fit\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicOverflow'
      }
    }
  }, [_vm._v("\n            Overflow   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-opacity"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Opacity\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Opacity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_opct-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("opacity")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_opct-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("100")]), _vm._v(" สำหรับ \"1\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("90")]), _vm._v(" สำหรับ \"0.9\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("80")]), _vm._v(" สำหรับ \"0.8\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("70")]), _vm._v(" สำหรับ \"0.7\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("60")]), _vm._v(" สำหรับ \"0.6\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("50")]), _vm._v(" สำหรับ \"0.5\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("40")]), _vm._v(" สำหรับ \"0.4\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("30")]), _vm._v(" สำหรับ \"0.3\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("20")]), _vm._v(" สำหรับ \"0.2\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("10")]), _vm._v(" สำหรับ \"0.1\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0")]), _vm._v(" สำหรับ \"0\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Display")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Opacity -->\n<div class=\"_bgcl-primary-900 _opct-100\"></div>\n<div class=\"_bgcl-primary-900 _opct-90\"></div>\n<div class=\"_bgcl-primary-900 _opct-80\"></div>\n<div class=\"_bgcl-primary-900 _opct-60\"></div>\n<div class=\"_bgcl-primary-900 _opct-50\"></div>\n<div class=\"_bgcl-primary-900 _opct-40\"></div>\n<div class=\"_bgcl-primary-900 _opct-30\"></div>\n<div class=\"_bgcl-primary-900 _opct-20\"></div>\n<div class=\"_bgcl-primary-900 _opct-10\"></div>\n<div class=\"_bgcl-primary-900 _opct-0\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px ghosty"
  }, [_c('div', {
    staticClass: "_h-64px _bgcl-primary-900 _opct-100"
  }), _vm._v(" "), _c('div', {
    staticClass: "_h-64px _bgcl-primary-900 _opct-90"
  }), _vm._v(" "), _c('div', {
    staticClass: "_h-64px _bgcl-primary-900 _opct-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "_h-64px _bgcl-primary-900 _opct-60"
  }), _vm._v(" "), _c('div', {
    staticClass: "_h-64px _bgcl-primary-900 _opct-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "_h-64px _bgcl-primary-900 _opct-40"
  }), _vm._v(" "), _c('div', {
    staticClass: "_h-64px _bgcl-primary-900 _opct-30"
  }), _vm._v(" "), _c('div', {
    staticClass: "_h-64px _bgcl-primary-900 _opct-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "_h-64px _bgcl-primary-900 _opct-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "_h-64px _bgcl-primary-900 _opct-0"
  })])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ Display ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicCursor'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Cursor\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicFloat'
      }
    }
  }, [_vm._v("\n            Float   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-display"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Display\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Display")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_dp-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("display")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_dp-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("b")]), _vm._v(" สำหรับ \"block\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("il")]), _vm._v(" สำหรับ \"inline\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("ilb")]), _vm._v(" สำหรับ \"inline-block\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("f")]), _vm._v(" สำหรับ \"flex\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("g")]), _vm._v(" สำหรับ \"grid\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("tb")]), _vm._v(" สำหรับ \"table\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("n")]), _vm._v(" สำหรับ \"none\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Display")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Display -->\n<div>\n  <div class=\"_dp-b\">Block</div>\n  <div class=\"_dp-b\">Block</div>\n  <div class=\"_dp-b\">Block</div>\n</div>\n\n<div>\n  <div class=\"_dp-il\">Inline</div>\n  <div class=\"_dp-il\">Inline</div>\n  <div class=\"_dp-il\">Inline</div>\n</div>\n\n<div class=\"_dp-f\">\n  <div>Flex Item</div>\n  <div>Flex Item</div>\n  <div>Flex Item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_mgbt-16px"
  }, [_c('div', {
    staticClass: "_dp-b _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Block")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-b _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Block")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-b _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Block")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-16px"
  }, [_c('div', {
    staticClass: "_dp-il _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Inline")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-il _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Inline")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-il _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Inline")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _mgbt-16px"
  }, [_c('div', {
    staticClass: "_dp-f _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Flex Item")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Flex Item")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Flex Item")])])])
}]}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Accordion ใช้สำหรับ เปิด/ปิด การแสดงผล Content ภายใน\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicZIndex'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Z Index\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentBreadcrumb'
      }
    }
  }, [_vm._v("\n            Breadcrumb   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-accordion"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Accordion\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-accordion")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-accordion-content")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n        ใช้งานร่วมกับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("<input>")]), _vm._v(" ได้สองแบบ\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('strong', [_vm._v("Checkbok")]), _vm._v(" (เปิดหลาย Accordion ได้พร้อมกัน)")]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("Radio")]), _vm._v(" (เปิดทีละ Accordion)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-accordion")])])]), _vm._v(" "), _c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".-has-icon")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-accordion-content")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Accordion แบบ Checkbox")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-accordion\">\n  <input id=\"ac1\" type=\"checkbox\">\n  <label for=\"ac1\"><strong>Accordion checkbox 1</strong></label>\n  <div class=\"bio-accordion-content\">\n    <div>Item A</div>\n    <div>Item B</div>\n    <div>Item C</div>\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-accordion"
  }, [_c('input', {
    attrs: {
      "id": "ac1",
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ac1"
    }
  }, [_c('strong', [_vm._v("Accordion checkbox 1")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content"
  }, [_c('div', [_vm._v("Item A")]), _vm._v(" "), _c('div', [_vm._v("Item B")]), _vm._v(" "), _c('div', [_vm._v("Item C")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่าง Accordion ที่ใช้ ")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".-has-icon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Accordion – With Icon -->\n<div class=\"bio-accordion -has-icon _mgbt-32px\">\n  <input id=\"ac2\" type=\"checkbox\" class=\"_dp-n\">\n  <label for=\"ac2\"><strong>Accordion checkbox 2</strong></label>\n  <div class=\"bio-accordion-content\">\n    <div class=\"bio-link -item\">Item A</div>\n    <div class=\"bio-link -item\">Item B</div>\n    <div class=\"bio-link -item\">Item C</div>\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-accordion -has-icon"
  }, [_c('input', {
    attrs: {
      "id": "ac2",
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ac2"
    }
  }, [_c('strong', [_vm._v("Accordion checkbox 2")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content"
  }, [_c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item A")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item B")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item C")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่าง Accordion แบบ Radio")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Accordion – With Icon -->\n<div class=\"bio-accordion\">\n  <input id=\"ar1\" type=\"radio\" name=\"ar\" class=\"_dp-n\">\n  <label for=\"ar1\"><strong>Accordion radio 1</strong></label>\n  <div class=\"bio-accordion-content\">\n    <div>Item A</div>\n    <div>Item B</div>\n    <div>Item C</div>\n  </div>\n</div>\n\n<div class=\"bio-accordion\">\n  <input id=\"ar2\" type=\"radio\" name=\"ar\" class=\"_dp-n\">\n  <label for=\"ar2\"><strong>Accordion radio 2</strong></label>\n  <div class=\"bio-accordion-content\">\n    <div>Item A</div>\n    <div>Item B</div>\n    <div>Item C</div>\n  </div>\n</div>\n\n<div class=\"bio-accordion\">\n  <input id=\"ar3\" type=\"radio\" name=\"ar\" class=\"_dp-n\">\n  <label for=\"ar3\"><strong>Accordion radio 3</strong></label>\n  <div class=\"bio-accordion-content\">\n    <div>Item A</div>\n    <div>Item B</div>\n    <div>Item C</div>\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-accordion _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "ar1",
      "type": "radio",
      "name": "ar"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ar1"
    }
  }, [_c('strong', [_vm._v("Accordion radio 1")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content"
  }, [_c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item A")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item B")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item C")])])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "ar2",
      "type": "radio",
      "name": "ar"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ar2"
    }
  }, [_c('strong', [_vm._v("Accordion radio 2")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content"
  }, [_c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item A")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item B")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item C")])])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion"
  }, [_c('input', {
    attrs: {
      "id": "ar3",
      "type": "radio",
      "name": "ar"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ar3"
    }
  }, [_c('strong', [_vm._v("Accordion radio 3")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content"
  }, [_c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item A")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item B")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item C")])])])])
}]}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ Float ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicDisplay'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Display\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicMargin'
      }
    }
  }, [_vm._v("\n            Margin   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-float"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Float\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Float")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_f-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("float")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_f-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("l")]), _vm._v(" สำหรับ \"left\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("r")]), _vm._v(" สำหรับ \"right\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("n")]), _vm._v(" สำหรับ \"none\""), _c('br')])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Float")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Display -->\n<div class=\"_f-l\"></div>\n<p>\n  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod\n  tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At\n  vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,\n  no sea takimata sanctus est Lorem ipsum dolor sit amet. consetetur sadipscing elitr, sed diam nonumy eirmod\n  tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At\n  vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,\n  no sea takimata sanctus est Lorem ipsum dolor sit amet.\n</p>\n\n<div class=\"_f-r\"></div>\n<p>\n  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod\n  tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At\n  vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,\n  no sea takimata sanctus est Lorem ipsum dolor sit amet. consetetur sadipscing elitr, sed diam nonumy eirmod\n  tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At\n  vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,\n  no sea takimata sanctus est Lorem ipsum dolor sit amet.\n</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_w-128px _h-64px _bgcl-gray _dp-ilb _f-l _mgr-8px"
  }, [_vm._v("Float Left")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-125pct _mgbt-32px"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod\n          tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At\n          vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,\n          no sea takimata sanctus est Lorem ipsum dolor sit amet. consetetur sadipscing elitr, sed diam nonumy eirmod\n          tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At\n          vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,\n          no sea takimata sanctus est Lorem ipsum dolor sit amet.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "_w-128px _h-64px _bgcl-gray _dp-ilb _f-r _mgr-8px"
  }, [_vm._v("Float Right")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-125pct"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod\n          tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At\n          vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,\n          no sea takimata sanctus est Lorem ipsum dolor sit amet. consetetur sadipscing elitr, sed diam nonumy eirmod\n          tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At\n          vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,\n          no sea takimata sanctus est Lorem ipsum dolor sit amet.\n        ")])])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_mgbt-16px _fs-3 _tal-ct _tal-l-sm"
  }, [_c('strong', [_vm._v("วิธีติดตั้ง Biomatic")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdrd-2px _pdh-16px _pdv-16px"
  }, [_c('p', {
    staticClass: "_mgbt-16px _fs-5 _mgt-8px"
  }, [_c('strong', [_vm._v("วิธีที่หนึ่ง – ")]), _vm._v(" "), _c('a', {
    staticClass: "bio-link -fancy",
    attrs: {
      "href": "https://github.com/BioMaRu/biomatic/releases/download/v0.1.4/biomatic.full.min.css.zip"
    }
  }, [_vm._v("ดาวน์โหลด CSS")]), _vm._v(" และลิงค์ไปยัง Project ของของคุณด้วย")]), _vm._v(" "), _c('pre', {
    staticClass: "_mgbt-32px"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<link href=\"/path/to/biomatic.css\" rel=\"stylesheet\">")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("วิธีที่สอง – ")]), _vm._v(" ติดตั้งผ่าน npm หรือ yarn")]), _vm._v(" "), _c('pre', {
    staticClass: "_mgbt-8px"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("npm install biomatic")])]), _vm._v(" "), _c('pre', {
    staticClass: "_mgbt-8px"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("yarn add biomatic")])])])])
}]}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-32px"
  }, [_vm._v("\n    ขั้นตอนการติดตั้ง\n  ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('a', {
    staticClass: "bio-button -accent -outline _mxw-256px _mgbt-64px",
    attrs: {
      "href": "https://github.com/BioMaRu/biomatic/releases/download/v0.1.4/biomatic.full.min.css.zip"
    }
  }, [_vm._v("\n    ดาวน์โหลด Biomatic\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n    หลังจากนั้น ทำการลิงค์ Biomatic ไปยังโปรเจคของคุณด้วย\n  ")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n    เท่านี้คุณก็พร้อมใช้งาน Biomatic ได้ทันที 🔥🔥\n  ")]), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'Introduction'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  เกี่ยวกับ Biomatic\n      ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'GettingStart'
      }
    }
  }, [_vm._v("\n        การใช้งาน   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-64px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#getting-start"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" การติดตั้ง\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("วิธีที่ 1")]), _vm._v(" – ติดตั้งผ่าน yarn หรือ npm วิธีนี้สะดวกสุด 👍\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('code', {
    staticClass: "_pd-12px _dp-b"
  }, [_vm._v("yarn add biomatic")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('code', {
    staticClass: "_pd-12px _dp-b"
  }, [_vm._v("npm install biomatic")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("วิธีที่ 2")]), _vm._v(" – ดาวโหลด Complied CSS 👌\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', [_c('pre', {
    staticClass: "_mgbt-64px"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<link href=\"/path/to/biomatic.css\" rel=\"stylesheet\">")])])])])
}]}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicMargin'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Margin\n        ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicOpacity'
      }
    }
  }, [_vm._v("\n          Opacity   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-object-fit"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Object Fit\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n      เป็น Atomic Class ที่ใช้กำหนดการ Fill Content ใน Container ของ Replaced Elements เช่น\n      "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("<img>")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("<iframe>")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("<embed>")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("<video>")]), _vm._v(" ประกอบไปด้วย\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Object Fit")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ojf-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("object-fit")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ojf-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("cv")]), _vm._v(" สำหรับ \"cover\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("ct")]), _vm._v(" สำหรับ \"contain\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("f")]), _vm._v(" สำหรับ \"fill\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("n")]), _vm._v(" สำหรับ \"none\"\n            ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน object-fit")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _pst-rlt _mgbt-64px"
  }, [_c('div', {
    staticClass: "_mgbt-32px"
  }, [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Original Image")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://placeimg.com/100/100/animals",
      "alt": "image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_dp-ilb"
  }, [_c('h6', [_vm._v("Cover")]), _vm._v(" "), _c('img', {
    staticClass: "_w-64px _h-128px _ojf-cv",
    attrs: {
      "src": "https://placeimg.com/100/100/animals",
      "alt": "image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_dp-ilb"
  }, [_c('h6', [_vm._v("Contain")]), _vm._v(" "), _c('img', {
    staticClass: "_w-64px _h-128px _ojf-ct _bgcl-neutral-300",
    attrs: {
      "src": "https://placeimg.com/100/100/animals",
      "alt": "image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_dp-ilb"
  }, [_c('h6', [_vm._v("Fill")]), _vm._v(" "), _c('img', {
    staticClass: "_w-64px _h-128px _ojf-f _bgcl-neutral-300",
    attrs: {
      "src": "https://placeimg.com/100/100/animals",
      "alt": "image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_dp-ilb"
  }, [_c('h6', [_vm._v("None")]), _vm._v(" "), _c('img', {
    staticClass: "_w-64px _h-128px _ojf-n _bgcl-neutral-300",
    attrs: {
      "src": "https://placeimg.com/100/100/animals",
      "alt": "image"
    }
  })])])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Tooltip ใช้แสดง Content ที่ซ่อนไว้ด้วยการ Hover Element ที่ต้องการ\n        เพื่อแสดงข้อมูลที่เกี่ยวข้องกับ Element โดย Content จะเป็นได้เพียง Text\n        ที่ระบุใน Attribute: data-tooltip เท่านั้น\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentProgress'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Progress\n          ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-tooltip"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Tooltip\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-tooltip")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-tooltip")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Position: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-top")]), _vm._v(" (default),\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-right")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-left")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-bottom")]), _vm._v(",\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Top -->\n<div class=\"bio-tooltip\" data-tooltip=\"Hello there!!!\">\n  Hover ME!! Top\n</div>\n\n<!-- Left -->\n<div class=\"bio-tooltip -left\" data-tooltip=\"Hello there!!!\">\n  Hover ME!! Left\n</div>\n\n<!-- Right -->\n<div class=\"bio-tooltip -right\" data-tooltip=\"Hello there!!!\">\n  Hover ME!! Right\n</div>\n\n<!-- Bottom -->\n<div class=\"bio-tooltip -bottom\" data-tooltip=\"Hello there!!!\">\n  Hover ME!! Bottom\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px _tal-ct"
  }, [_c('div', {
    staticClass: "bio-tooltip _dp-ilb _mgbt-16px",
    attrs: {
      "data-tooltip": "Hello there!!!"
    }
  }, [_vm._v("Hover ME!! Top")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bio-tooltip -left _dp-ilb _mgbt-16px",
    attrs: {
      "data-tooltip": "Hello there!!!"
    }
  }, [_vm._v("Hover ME!! Left")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bio-tooltip -right _dp-ilb _mgbt-16px",
    attrs: {
      "data-tooltip": "Hello there!!!"
    }
  }, [_vm._v("Hover ME!! Right")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bio-tooltip -bottom _dp-ilb",
    attrs: {
      "data-tooltip": "Hello there!!!"
    }
  }, [_vm._v("Hover ME!! Bottom")]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน รูปแบบอื่น")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-tooltip\" data-tooltip=\"I'm a button\">\n  <div class=\"bio-button\">Button</div>\n</div>\n\n<div class=\"bio-tooltip -right\" data-tooltip=\"I'm a Link\">\n  <a class=\"bio-link -fancy\">Link</a>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-tooltip _dp-ilb",
    attrs: {
      "data-tooltip": "I'm a button"
    }
  }, [_c('div', {
    staticClass: "bio-button"
  }, [_vm._v("Button")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-tooltip -right _dp-ilb",
    attrs: {
      "data-tooltip": "I'm a Link"
    }
  }, [_c('a', {
    staticClass: "bio-link -fancy"
  }, [_vm._v("Link")])])])
}]}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ Color ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBoxSize'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Box Size\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicCursor'
      }
    }
  }, [_vm._v("\n            Cursor   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-color"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Color\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_cl-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("color")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_cl-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Biomatic's Color Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("primary[-{100-900}]")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("accent[-{100-900}]")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("neutral[-{100-900}]")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("positive")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("negative")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("warning")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("white")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("gray")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("dark")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("black")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-hover")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Main Color -->\n<p class=\"_cl-primary\">Hello World</p>\n<p class=\"_cl-accent\">Hello World</p>\n<p class=\"_cl-neutral\">Hello World</p>\n\n<!-- Semantic Color -->\n<p class=\"_cl-positive\">Hello World</p>\n<p class=\"_cl-negative\">Hello World</p>\n<p class=\"_cl-warning\">Hello World</p>\n<p class=\"_cl-info\">Hello World</p>\n\n<!-- Gray Scale Color -->\n<p class=\"_cl-white\">Hello World</p>\n<p class=\"_cl-gray\">Hello World</p>\n<p class=\"_cl-dark\">Hello World</p>\n<p class=\"_cl-black\">Hello World</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('p', {
    staticClass: "_cl-primary"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-positive"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-negative"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-warning"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-info"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-white"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-gray"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-dark"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-black"
  }, [_vm._v("Hello World")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Main Color – Primary พร้อม Weight Modifier")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Primary Color -->\n<p class=\"_cl-primary-100\">Hello World</p>\n<p class=\"_cl-primary-200\">Hello World</p>\n<p class=\"_cl-primary-300\">Hello World</p>\n<p class=\"_cl-primary-400\">Hello World</p>\n<p class=\"_cl-primary-500\">Hello World</p>\n<p class=\"_cl-primary-600\">Hello World</p>\n<p class=\"_cl-primary-700\">Hello World</p>\n<p class=\"_cl-primary-800\">Hello World</p>\n<p class=\"_cl-primary-900\">Hello World</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('p', {
    staticClass: "_cl-primary-100"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-200"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-300"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-400"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-500"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-600"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-700"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-800"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-primary-900"
  }, [_vm._v("Hello World")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Main Color – Accent พร้อม Weight Modifier")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Accent Color -->\n<p class=\"_cl-accent-100\">Hello World</p>\n<p class=\"_cl-accent-200\">Hello World</p>\n<p class=\"_cl-accent-300\">Hello World</p>\n<p class=\"_cl-accent-400\">Hello World</p>\n<p class=\"_cl-accent-500\">Hello World</p>\n<p class=\"_cl-accent-600\">Hello World</p>\n<p class=\"_cl-accent-700\">Hello World</p>\n<p class=\"_cl-accent-800\">Hello World</p>\n<p class=\"_cl-accent-900\">Hello World</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('p', {
    staticClass: "_cl-accent-100"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-200"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-300"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-400"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-500"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-600"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-700"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-800"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-accent-900"
  }, [_vm._v("Hello World")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Main Color – Neutral พร้อม Weight Modifier")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Neutral Color -->\n<p class=\"_cl-neutral-100\">Hello World</p>\n<p class=\"_cl-neutral-200\">Hello World</p>\n<p class=\"_cl-neutral-300\">Hello World</p>\n<p class=\"_cl-neutral-400\">Hello World</p>\n<p class=\"_cl-neutral-500\">Hello World</p>\n<p class=\"_cl-neutral-600\">Hello World</p>\n<p class=\"_cl-neutral-700\">Hello World</p>\n<p class=\"_cl-neutral-800\">Hello World</p>\n<p class=\"_cl-neutral-900\">Hello World</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('p', {
    staticClass: "_cl-neutral-100"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-200"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-300"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-400"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-500"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-600"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-700"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-800"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_cl-neutral-900"
  }, [_vm._v("Hello World")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Color – Hover")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<p class=\"_cl-positive _cl-negative-hover\">\n  Hover Me\n</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('p', {
    staticClass: "_cl-positive _cl-negative-hover _dp-ilb"
  }, [_vm._v("Hover Me")])])
}]}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_mgbt-16px _fs-3 _tal-ct _tal-l-sm"
  }, [_c('strong', [_vm._v("Biomatic เบื้องต้น")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdrd-2px _pdh-16px _pdv-16px"
  }, [_c('p', {
    staticClass: "_pdl-8px _fs-4 _mgbt-8px _cl-accent"
  }, [_c('strong', [_vm._v("Atomic Class")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-16px _mgbt-8px "
  }, [_vm._v("\n        • เป็นหัวใจหลักของ Biomatic ใช้กำหนดค่า Style หรือใช้ร่วมกับ Class อื่นๆ เพื่อแสดงผลลัพท์ที่ต้องการ\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-16px _mgbt-8px"
  }, [_vm._v("\n        • ใช้ Prefix "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("_*")]), _vm._v(" และชื่อ Class เป็นคู่ของ Name-Value เช่น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("_mgl-8px")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-16px _mgbt-8px"
  }, [_vm._v("\n        • Name, Value จะเป็นตัวย่อตามพยางค์ของการออกเสียง"), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("margin-left: 8px")]), _vm._v(" เป็น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("_mgr-8px")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("padding-bottom: auto")]), _vm._v(" เป็น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("_pdbt-at")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("width: 100%")]), _vm._v(" เป็น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("_w-100pct")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("text-align: center")]), _vm._v(" เป็น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("_tal-ct")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-16px _mgbt-8px"
  }, [_vm._v("\n        • สามารถใส่ Breakpoint "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-sm")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-md")]), _vm._v(" และ "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-lg")]), _vm._v("\n        ที่ Class เพื่อกำหนดการแสดงผลแบบ Responsive ได้\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "_pdl-24px-sm _mgbt-8px"
  }, [_c('pre', [_vm._v("          "), _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!--\nText-align Left,\nText-align Center on SMALL size or upper,\nText-align Right on MEDIUM size or upper,\nHeight of 32pixel,\nPositive background color,\nWarning background color on SMALL size or upper,\n-->\n<div class=\"_tal-l _tal-ct-sm _tal-r-md _h-32px _bgcl-positive _bgcl-warning-md\">\n  item\n</div>\n")])])]), _vm._v(" "), _c('div', {
    staticClass: "lo-12 _mgbt-64px"
  }, [_c('div', {
    staticClass: "_tal-l _tal-ct-sm _tal-r-md _h-32px _bgcl-positive _bgcl-warning-sm"
  }, [_vm._v("\n            item\n          ")])])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-8px _cl-accent _fs-4"
  }, [_c('strong', [_vm._v("Components Class")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • สำหรับใช้แสดงผล Element ต่างๆ เช่น Button, Breadcrumb หรือ Accordion เป็นต้น\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • ใช้ Prefix "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("bio-")]), _vm._v(" เช่น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("bio-button")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("bio-link")])]), _vm._v(" "), _c('div', {
    staticClass: "_tal-ct _pdl-24px-sm _mgbt-32px"
  }, [_c('div', {
    staticClass: "_dp-f _fdrt-cl _fdrt-r-sm _mgbt-8px"
  }, [_c('div', {
    staticClass: "bio-button _mgr-8px-sm _mgbt-8px"
  }, [_vm._v("bio-button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link _als-ct"
  }, [_vm._v("bio-link")])])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • ใส่ Option ด้วย "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-*")]), _vm._v(" เช่น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("bio-button -loading")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("bio-button -positive -outline")]), _vm._v("\n        ซึ่งรูปแบบการลักษณะนี้ จะหมือนกับ Switched ใน UNIX commandline เช่น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("ls -a")]), _vm._v(" เป็นต้น\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "_tal-ct _pdl-24px-sm _mgbt-64px"
  }, [_c('div', {
    staticClass: "_dp-f _fdrt-cl _fdrt-r-sm _alit-fst-sm _mgbt-8px"
  }, [_c('div', {
    staticClass: "bio-button -loading _mgr-8px-sm _mgbt-8px"
  }, [_vm._v("bio-button -loading")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -outline"
  }, [_vm._v("bio-button -positive -outline")])])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px _cl-accent _fs-4"
  }, [_c('strong', [_vm._v("Layout Class")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • ใช้เป็น Container เพื่อการจัดวาง และการแสดงผลของ Contents หรือ Component ด้านใน\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • Responsive grid ใช้ Grid 12\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • Breakpoints มีสามขนาดใ ช้ Suffix เป็น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-sm")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-md")]), _vm._v(" และ "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-lg")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • ใช้ Prefix "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("lo-")]), _vm._v(" เช่น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("lo-container")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("lo-4")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("lo-8-2")]), _vm._v(" "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("lo-7-5-sm")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • ใส่ Option ด้วย "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-*")]), _vm._v(" เช่น เพื่อตั้งค่าการแสดงผล เช่น ขนาด Gutter ได้\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "_pdl-24px-sm _mgbt-32px"
  }, [_c('pre', [_vm._v("          "), _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"lo-4 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])]), _vm._v(" "), _c('div', {
    staticClass: "lo-4 -gap-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-500 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-500 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-500 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])])]), _vm._v(" "), _c('div', {
    staticClass: "_pdl-24px-sm _mgbt-64px"
  }, [_c('pre', [_vm._v("          "), _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"lo-12 lo-8-4-sm -gapv-12px -gaph-2px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])]), _vm._v(" "), _c('div', {
    staticClass: "lo-12 lo-8-4-sm -gapv-12px -gaph-2px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-500 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-500 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-500 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px _cl-accent _fs-4"
  }, [_c('strong', [_vm._v("Utility Class")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • ใช้เพิ่มการแสดงผลพฤติกรรม หรืออำนวยความสะดวกต่างๆ เช่น Animation\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • ใช้ Prefix "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("u-")]), _vm._v(" เช่น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("u-animation-*")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("u-hover-*")])]), _vm._v(" "), _c('div', {
    staticClass: "_tal-ct _pdl-16px _mgbt-16px"
  }, [_c('div', {
    staticClass: "_dp-f _fdrt-cl _fdrt-r-sm _alit-fst-sm _mgbt-8px"
  }, [_c('div', {
    staticClass: "bio-button _mgr-8px _mgbt-24px _mgbt-0px-sm u-animation-pulse"
  }, [_vm._v("bio-button u-animation-pulse")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button u-rise"
  }, [_vm._v("bio-button u-rise")])])])])])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Typography ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-font-size"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-font-weight"
    }
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-line-height"
    }
  }), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดความหนาของ Line Height\n      ")]), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-text-align"
    }
  }), _vm._v(" "), _vm._m(37), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดความหนาของ Alignment ของ Inline Content ด้านใน Container\n      ")]), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-text-transform"
    }
  }), _vm._v(" "), _vm._m(48), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้กำหนด Text Transform ให้กับ Text ของ Element\n      ")]), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-letter-spacing"
    }
  }), _vm._v(" "), _vm._m(59), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดระยะห่างระหว่างตัวอักษร\n      ")]), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _vm._m(62), _vm._v(" "), _vm._m(63), _vm._v(" "), _vm._m(64), _vm._v(" "), _vm._m(65), _vm._v(" "), _vm._m(66), _vm._v(" "), _vm._m(67), _vm._v(" "), _vm._m(68), _vm._v(" "), _vm._m(69), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-white-space"
    }
  }), _vm._v(" "), _vm._m(70), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดการจัดการกับ White Space\n      ")]), _vm._v(" "), _vm._m(71), _vm._v(" "), _vm._m(72), _vm._v(" "), _vm._m(73), _vm._v(" "), _vm._m(74), _vm._v(" "), _vm._m(75), _vm._v(" "), _vm._m(76), _vm._v(" "), _vm._m(77), _vm._v(" "), _vm._m(78), _vm._v(" "), _vm._m(79), _vm._v(" "), _vm._m(80), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicPadding'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Padding\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicZIndex'
      }
    }
  }, [_vm._v("\n            Z Index   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-typography"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Typography\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-128px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-font-size"
    }
  }, [_vm._v("Font Size")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-font-weight"
    }
  }, [_vm._v("Font Weight")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-line-height"
    }
  }, [_vm._v("Line Height")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-text-align"
    }
  }, [_vm._v("Text Align")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-text-transform"
    }
  }, [_vm._v("Text Transform")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-letter-spacing"
    }
  }, [_vm._v("Letter Spacing")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-white-space"
    }
  }, [_vm._v("White Space")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-font-size"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Font Size\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดขนาดของ Font Size โดย Value จะเป็นค่าระดับขนาดของ Font ตั้งแต่\n        "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1")]), _vm._v(" ถึง "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fs-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("font-size")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Value")]), _vm._v(" "), _c('th', [_vm._v("ขนาดของ Font")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("3rem")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2.5rem")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("3")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2rem")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1.5rem")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("5")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1.125rem")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("6")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1rem")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("7")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0.85rem")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0.7rem")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Font Size")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Font Size -->\n<p class=\"_fs-1\">Hello World</p>\n<p class=\"_fs-2\">Hello World</p>\n<p class=\"_fs-3\">Hello World</p>\n<p class=\"_fs-4\">Hello World</p>\n<p class=\"_fs-5\">Hello World</p>\n<p class=\"_fs-6\">Hello World</p>\n<p class=\"_fs-7\">Hello World</p>\n<p class=\"_fs-8\">Hello World</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('p', {
    staticClass: "_fs-1"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-2"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-3"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-4"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-5"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-6"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-7"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-8"
  }, [_vm._v("Hello World")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-font-weight"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Font Weight\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดความหนาของ Font โดย Value จะเป็นค่าที่กำหนดใน "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("font-weight")]), _vm._v(" ระดับตั้งแต่\n        "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("100")]), _vm._v(" ถึง "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("900")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("font-weight")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fw-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("100")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("200")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("300")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("400")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("500")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("600")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("700")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("800")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("900")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Font Weight")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Font Weight -->\n<p class=\"_fw-100\">Hello World</p>\n<p class=\"_fw-200\">Hello World</p>\n<p class=\"_fw-300\">Hello World</p>\n<p class=\"_fw-400\">Hello World</p>\n<p class=\"_fw-500\">Hello World</p>\n<p class=\"_fw-600\">Hello World</p>\n<p class=\"_fw-700\">Hello World</p>\n<p class=\"_fw-800\">Hello World</p>\n<p class=\"_fw-900\">Hello World</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('p', {
    staticClass: "_fw-100"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-200"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-300"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-400"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-500"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-600"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-700"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-800"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-900"
  }, [_vm._v("Hello World")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-line-height"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Line Height\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_lh-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("line-height")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_lh-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Percentage Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("100pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("125pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("150pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("175pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("200pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("225pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("250pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("275pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("300pct")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Line Height")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Line Height -->\n<p class=\"_lh-100pct\">._lh-100pct</p>\n<p class=\"_lh-125pct\">._lh-125pct</p>\n<p class=\"_lh-150pct\">._lh-150pct</p>\n<p class=\"_lh-175pct\">._lh-175pct</p>\n<p class=\"_lh-200pct\">._lh-200pct</p>\n<p class=\"_lh-225pct\">._lh-225pct</p>\n<p class=\"_lh-250pct\">._lh-250pct</p>\n<p class=\"_lh-275pct\">._lh-275pct</p>\n<p class=\"_lh-300pct\">._lh-300pct</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('p', {
    staticClass: "_lh-100pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-100pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-125pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-125pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-150pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-150pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-175pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-175pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-200pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-200pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-225pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-225pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-250pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-250pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-275pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-275pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-300pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-300pct")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-text-align"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Text Align\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_tal-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("text-align")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_tal-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("l")]), _vm._v(" สำหรับ \"left\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("r")]), _vm._v(" สำหรับ \"right\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("ct")]), _vm._v(" สำหรับ \"center\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("jtf")]), _vm._v(" สำหรับ \"justify\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Text Align")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Text Align -->\n<p class=\"_tal-l\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n  Pellentesque sit amet vel velit finibus ullamcorper.\n  Aenean in tellus vel nibh imperdiet semper eget eu turpis\n</p>\n<p class=\"_tal-r\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n  Pellentesque sit amet vel velit finibus ullamcorper.\n  Aenean in tellus vel nibh imperdiet semper eget eu turpis\n</p>\n<p class=\"_tal-ct\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n  Pellentesque sit amet vel velit finibus ullamcorper.\n  Aenean in tellus vel nibh imperdiet semper eget eu turpis\n</p>\n<p class=\"_tal-jtf\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n  Pellentesque sit amet vel velit finibus ullamcorper.\n  Aenean in tellus vel nibh imperdiet semper eget eu turpis\n</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('p', {
    staticClass: "_tal-l _mgbt-8px _bdw-2px _bdcl-neutral-500 _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          Pellentesque sit amet vel velit finibus ullamcorper.\n          Aenean in tellus vel nibh imperdiet semper eget eu turpis\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "_tal-r _mgbt-8px _bdw-2px _bdcl-neutral-500 _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          Pellentesque sit amet vel velit finibus ullamcorper.\n          Aenean in tellus vel nibh imperdiet semper eget eu turpis\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "_tal-ct _mgbt-8px _bdw-2px _bdcl-neutral-500 _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          Pellentesque sit amet vel velit finibus ullamcorper.\n          Aenean in tellus vel nibh imperdiet semper eget eu turpis\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "_tal-jtf _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          Pellentesque sit amet vel velit finibus ullamcorper.\n          Aenean in tellus vel nibh imperdiet semper eget eu turpis\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-text-transform"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Text Transform\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ttf-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("text-transform")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ttf-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("cptl")]), _vm._v(" สำหรับ \"capitalize\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("lwc")]), _vm._v(" สำหรับ \"lowercase\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("upc")]), _vm._v(" สำหรับ \"uppercase\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("n")]), _vm._v(" สำหรับ \"none\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Text Transform")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<p class=\"_ttf-n\">hello world</p>\n<p class=\"_ttf-cptl\">hello world</p>\n<p class=\"_ttf-upc\">hello world</p>\n<p class=\"_ttf-lwc\">hello world</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('p', {
    staticClass: "_ttf-n"
  }, [_vm._v("hello world")]), _vm._v(" "), _c('p', {
    staticClass: "_ttf-cptl"
  }, [_vm._v("hello world")]), _vm._v(" "), _c('p', {
    staticClass: "_ttf-upc"
  }, [_vm._v("hello world")]), _vm._v(" "), _c('p', {
    staticClass: "_ttf-lwc"
  }, [_vm._v("hello world")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-letter-spacing"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Letter Spacing\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ltspc-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("letter-spacing")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-14px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ltspc-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Pixel Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("32px")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Letter Spacing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Line Height -->\n<p class=\"_ltspc-1px\">Meowwloo</p>\n<p class=\"_ltspc-2px\">Meowwloo</p>\n<p class=\"_ltspc-4px\">Meowwloo</p>\n<p class=\"_ltspc-8px\">Meowwloo</p>\n<p class=\"_ltspc-16px\">Meowwloo</p>\n<p class=\"_ltspc-32px\">Meowwloo</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('p', {
    staticClass: "_ltspc-1px _mgbt-8px"
  }, [_vm._v("Meowwloo")]), _vm._v(" "), _c('p', {
    staticClass: "_ltspc-2px _mgbt-8px"
  }, [_vm._v("Meowwloo")]), _vm._v(" "), _c('p', {
    staticClass: "_ltspc-4px _mgbt-8px"
  }, [_vm._v("Meowwloo")]), _vm._v(" "), _c('p', {
    staticClass: "_ltspc-8px _mgbt-8px"
  }, [_vm._v("Meowwloo")]), _vm._v(" "), _c('p', {
    staticClass: "_ltspc-16px _mgbt-8px"
  }, [_vm._v("Meowwloo")]), _vm._v(" "), _c('p', {
    staticClass: "_ltspc-32px"
  }, [_vm._v("Meowwloo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-white-space"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" White Space\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ws-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("white-space")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_wsp-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("nm")]), _vm._v(" สำหรับ \"normal\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("nw")]), _vm._v(" สำหรับ \"no-wrap\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("p")]), _vm._v(" สำหรับ \"pre\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("pl")]), _vm._v(" สำหรับ \"pre-line\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("pw")]), _vm._v(" สำหรับ \"pre-wrap\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน White Space")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- White Space -->\n<div class=\"_wsp-nm\">   A B C D E F</div>\n<div class=\"_wsp-nw\">   A B C D E F</div>\n<div class=\"_wsp-p\">   A B C D E F</div>\n<div class=\"_wsp-pl\">   A B C D E F</div>\n<div class=\"_wsp-pw\">   A B C D E F</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_wsp-nm _w-64px _bdw-2px _bdcl-neutral-500 _h-64px _mgbt-8px _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("   A B C D E F")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _w-64px _bdw-2px _bdcl-neutral-500 _h-64px _mgbt-8px _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("   A B C D E F")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-p _w-64px _bdw-2px _bdcl-neutral-500 _h-64px _mgbt-8px _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("   A B C D E F")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-pl _w-64px _bdw-2px _bdcl-neutral-500 _h-64px _mgbt-8px _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("   A B C D E F")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-pw _w-64px _bdw-2px _bdcl-neutral-500 _h-64px _mgbt-8px _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("   A B C D E F")])])
}]}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้กำหนดการพฤติกรรมของ Overflow Content ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-overflow"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Overflow ใช้กำหนดการจัดการ Overflow Content\n      ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-overflow"
    }
  }), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Text Overflow ใช้กำหนดการจัดการ Overflow ของ Text ใน Container\n      ")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicOpacity'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Opacity\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicPadding'
      }
    }
  }, [_vm._v("\n            Padding   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-overflow"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Overflow\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-128px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-overflow"
    }
  }, [_vm._v("Overflow")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-text-overflow"
    }
  }, [_vm._v("Text Overflow")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-overflow"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Overflow\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ovf-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("overflow")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ovfx-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("overflow")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ovfy-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("overflow")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ovf-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ovfx-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ovfy-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("vsb")]), _vm._v(" สำหรับ \"visible\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("at")]), _vm._v(" สำหรับ \"auto\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("hd")]), _vm._v(" สำหรับ \"hidden\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("sc")]), _vm._v(" สำหรับ \"scroll\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน overflow")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Overflow Visible -->\n<div class=\"_w-128px _ovf-vsb\">\n  <div class=\"_w-256px\"></div>\n</div>\n\n<!-- Overflow Hidden -->\n<div class=\"_w-128px _ovf-hd\">\n  <div class=\"_w-256px\"></div>\n</div>\n\n<!-- Overflow Auto -->\n<div class=\"_w-128px _ovf-at\">\n  <div class=\"_w-256px\"></div>\n</div>\n\n<!-- Overflow Scroll -->\n<div class=\"_w-128px _ovf-sc\">\n  <div class=\"_w-256px\"></div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _pst-rlt _mgbt-128px"
  }, [_c('div', [_vm._v("Overflow Visible")]), _vm._v(" "), _c('div', {
    staticClass: "_w-128px _h-64px _bgcl-neutral-300 _mgbt-32px _ovf-vsb"
  }, [_c('div', {
    staticClass: "_w-256px _h-24px _bgcl-neutral-500"
  })]), _vm._v(" "), _c('div', [_vm._v("Overflow Hidden")]), _vm._v(" "), _c('div', {
    staticClass: "_w-128px _h-64px _bgcl-neutral-300 _mgbt-32px _ovf-hd"
  }, [_c('div', {
    staticClass: "_w-256px _h-24px _bgcl-neutral-500"
  })]), _vm._v(" "), _c('div', [_vm._v("Overflow Auto")]), _vm._v(" "), _c('div', {
    staticClass: "_w-128px _h-64px _bgcl-neutral-300 _mgbt-32px _ovf-at"
  }, [_c('div', {
    staticClass: "_w-256px _h-24px _bgcl-neutral-500"
  })]), _vm._v(" "), _c('div', [_vm._v("Overflow Scroll")]), _vm._v(" "), _c('div', {
    staticClass: "_w-128px _h-64px _bgcl-neutral-300 _ovf-sc"
  }, [_c('div', {
    staticClass: "_w-256px _h-24px _bgcl-neutral-500"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-overflow"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Text Overflow\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_tovf-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("text-overflow")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_tovf-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("c")]), _vm._v(" สำหรับ \"clip\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("els")]), _vm._v(" สำหรับ \"ellipsis\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -primary _fs-6 _mgbt-64px"
  }, [_c('p', [_c('strong', [_vm._v("คำแนะนำ")]), _vm._v(" – Class "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_tovf-*")]), _vm._v("\n          นั้นจะต้องระบุ Style "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("white-space: nowrap")]), _vm._v("\n          เพื่อให้ Text Content ล้น Container ออกมา และ Style "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("overflow: hidden")]), _vm._v("\n          เพื่อซ่อน Text Content ที่ Overflow ด้วย จึงจะแสดงผลได้ 💁\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน text-overflow")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Normal Text Overflow -->\n<div>\n  <p class=\"_wsp-nw\">\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n  </p>\n</div>\n\n<!-- Text Overflow Clip -->\n<div>\n  <p class=\"_wsp-nw _ovf-hd _tovf-c\">\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n  </p>\n</div>\n\n<!-- Text Overflow Ellipsis -->\n<div>\n  <p class=\"_wsp-nw _ovf-hd _tovf-els\">\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n  </p>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _pst-rlt _mgbt-64px"
  }, [_c('h6', [_vm._v("Normal Text Overflow")]), _vm._v(" "), _c('div', {
    staticClass: "_w-128px _h-64px _bgcl-neutral-300 _mgbt-32px"
  }, [_c('p', {
    staticClass: "_wsp-nw"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          ")])]), _vm._v(" "), _c('h6', [_vm._v("Text Overflow Clip")]), _vm._v(" "), _c('div', {
    staticClass: "_w-128px _h-64px _bgcl-neutral-300 _mgbt-32px"
  }, [_c('p', {
    staticClass: "_wsp-nw _ovf-hd _tovf-c"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          ")])]), _vm._v(" "), _c('h6', [_vm._v("Text Overflow Ellipsis")]), _vm._v(" "), _c('div', {
    staticClass: "_w-128px _h-64px _bgcl-neutral-300"
  }, [_c('p', {
    staticClass: "_wsp-nw _ovf-hd _tovf-els"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          ")])])])
}]}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ Cursor ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicColor'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Color\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicDisplay'
      }
    }
  }, [_vm._v("\n            Display   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-cursor"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Cursor\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Cursor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_cs-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("cursor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_cs-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("pt")]), _vm._v(": สำหรับ \"pointer\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("h")]), _vm._v(": สำหรับ \"help\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("nal")]), _vm._v(": สำหรับ \"not-allowed\" "), _c('br')])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Cursor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Cursor -->\n<div class=\"_cs-pt\">Pointer</div>\n<div class=\"_cs-h\">Help</div>\n<div class=\"_cs-nal\">Not Allowed</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_h-32px _bgcl-white _tal-ct _cs-pt _bdw-1px _bdcl-neutral-400 _mgbt-16px"
  }, [_vm._v("Pointer")]), _vm._v(" "), _c('div', {
    staticClass: "_h-32px _bgcl-white _tal-ct _cs-h _bdw-1px _bdcl-neutral-400 _mgbt-16px"
  }, [_vm._v("Help")]), _vm._v(" "), _c('div', {
    staticClass: "_h-32px _bgcl-white _tal-ct _cs-nal _bdw-1px _bdcl-neutral-400"
  }, [_vm._v("Not Allowed")])])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HomeBanner', {
    staticClass: "_mgbt-32px _mgbt-64px-sm"
  }), _vm._v(" "), _c('HomeBenefits', {
    staticClass: "_mgbt-64px"
  }), _vm._v(" "), _c('HomeGettingStart')], 1)
},staticRenderFns: []}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isShowNavbar) ? _c('TheNavbar', {
    ref: "TheNavBar",
    attrs: {
      "is-color": _vm.isNavbarColor
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "id": "app-content"
    }
  }), _vm._v(" "), (_vm.isShowFooter) ? _c('TheFooter', {
    ref: "TheFooter"
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ Border ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-border-width"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-border-color"
    }
  }), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n        ใช้กำหนดสีของ Border\n      ")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-border-radius"
    }
  }), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n        ใช้กำหนดรัศมีของ Border\n      ")]), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBackground'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("   Background\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBoxPosition'
      }
    }
  }, [_vm._v("\n            Box Position   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-border"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Border\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-128px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-border-width"
    }
  }, [_vm._v("Border Width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-border-color"
    }
  }, [_vm._v("Border Color")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-border-radius"
    }
  }, [_vm._v("Border Radius")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-border-width"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Border Width\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n        ใช้กำหนดความหนาของ Border โดย Biomatic จะใช้ Default\n        "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-style")]), _vm._v(" เป็น\n        "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("solid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -primary _fs-6 _mgbt-64px"
  }, [_c('p', [_c('strong', [_vm._v("คำแนะนำ")]), _vm._v(" – ตอนนี้ Biomatic ยังไม่มี Class ที่ใช้กำหนด Border Style เป็นแบบอื่น\n          เพราะ Border Style อื่น นอกจาก solid มักไม่ค่อยมีการใช้งาน\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdlw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-left-width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdrw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-right-width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdtw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-top-width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdbtw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-bottom-width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdvw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-top-width")]), _vm._v(" และ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-bottom-width")]), _vm._v(" "), _c('small', {
    staticClass: "_opct-50"
  }, [_vm._v("(Vertical)")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdhw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-left-width")]), _vm._v(" และ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-right-width")]), _vm._v(" "), _c('small', {
    staticClass: "_opct-50"
  }, [_vm._v("(Horizontal)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdw-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdlw-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdrw-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdtw-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdbtw-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdvw-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdhw-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Pixel Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("12px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("24px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("48px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("64px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("128px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("256px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("512px")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Border Width")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Border Width-->\n<div class=\"_bdw-4px\"></div>\n<div class=\"_bdw-8px\"></div>\n<div class=\"_bdw-16px\"></div>\n\n<!-- Border Left Width -->\n<div class=\"_bdlw-4px\"></div>\n<div class=\"_bdlw-8px\"></div>\n<div class=\"_bdlw-16px\"></div>\n\n<!-- Border Right Width -->\n<div class=\"_bdrw-4px\"></div>\n<div class=\"_bdrw-8px\"></div>\n<div class=\"_bdrw-16px\"></div>\n\n<!-- Border Top Width -->\n<div class=\"_bdtw-4px\"></div>\n<div class=\"_bdtw-8px\"></div>\n<div class=\"_bdtw-16px\"></div>\n\n<!-- Border Bottom Width -->\n<div class=\"_bdbtw-4px\"></div>\n<div class=\"_bdbtw-8px\"></div>\n<div class=\"_bdbtw-16px\"></div>\n\n<!-- Border Vertical Width -->\n<div class=\"_bdvw-4px\"></div>\n<div class=\"_bdvw-8px\"></div>\n<div class=\"_bdvw-16px\"></div>\n\n<!-- Border Left Width with Breakpoint -->\n<div class=\"_bdlw-0px _bdlw-32px-sm\"></div>\n<div class=\"_bdlw-0px _bdlw-32px-md\"></div>\n<div class=\"_bdlw-0px _bdlw-32px-lg\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdw-4px _mgbt-8px"
  }, [_vm._v("_bdw-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdw-8px _mgbt-8px"
  }, [_vm._v("_bdw-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdw-16px _mgbt-32px"
  }, [_vm._v("_bdw-16px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdlw-4px _mgbt-8px"
  }, [_vm._v("_bdlw-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdlw-8px _mgbt-8px"
  }, [_vm._v("_bdlw-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdlw-16px _mgbt-32px"
  }, [_vm._v("_bdlw-16px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdrw-4px _mgbt-8px"
  }, [_vm._v("_bdrw-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdrw-8px _mgbt-8px"
  }, [_vm._v("_bdrw-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdrw-16px _mgbt-32px"
  }, [_vm._v("_bdrw-16px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdtw-4px _mgbt-8px"
  }, [_vm._v("_bdtw-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdtw-8px _mgbt-8px"
  }, [_vm._v("_bdtw-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdtw-16px _mgbt-32px"
  }, [_vm._v("_bdtw-16px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdbtw-4px _mgbt-8px"
  }, [_vm._v("_bdbtw-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdbtw-8px _mgbt-8px"
  }, [_vm._v("_bdbtw-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdbtw-16px _mgbt-32px"
  }, [_vm._v("_bdbtw-16px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdvw-4px _mgbt-8px"
  }, [_vm._v("_bdvw-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdvw-8px _mgbt-8px"
  }, [_vm._v("_bdvw-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdvw-16px _mgbt-32px"
  }, [_vm._v("_bdvw-16px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdhw-4px _mgbt-8px"
  }, [_vm._v("_bdhw-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdhw-8px _mgbt-8px"
  }, [_vm._v("_bdhw-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdhw-16px _mgbt-32px"
  }, [_vm._v("_bdhw-16px")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdlw-0px _bdlw-32px-sm _mgbt-8px"
  }, [_vm._v("_bdlw-0px _bdlw-32px-sm")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdlw-0px _bdlw-32px-md _mgbt-8px"
  }, [_vm._v("_bdlw-0px _bdlw-32px-md")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdcl-neutral-700 _wsp-nw _bdlw-0px _bdlw-32px-lg _mgbt-8px"
  }, [_vm._v("_bdlw-0px _bdlw-32px-lg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-border-color"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Border Color\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdcl-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-color")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdcl-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Biomatic's Color Name Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("primary")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("accent")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("neutral")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("positive")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("negative")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("warning")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("white")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("gray")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("dark")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("black")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-hover")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Border Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Border Color -->\n<div class=\"_bdw-2px _bdcl-primary\"></div>\n<div class=\"_bdw-2px _bdcl-accent\"></div>\n<div class=\"_bdw-2px _bdcl-positive\"></div>\n<div class=\"_bdw-2px _bdcl-negative\"></div>\n<div class=\"_bdw-2px _bdcl-warning\"></div>\n<div class=\"_bdw-2px _bdcl-info\"></div>\n\n<!-- Gray Scale Border Color -->\n<div class=\"_bdw-2px _bdcl-white\"></div>\n<div class=\"_bdw-2px _bdcl-gray\"></div>\n<div class=\"_bdw-2px _bdcl-dark\"></div>\n<div class=\"_bdw-2px _bdcl-black\"></div>\n\n<!-- Primary Border Color with Ligthness Modifier -->\n<div class=\"_bdw-2px _bdcl-primary-900\"></div>\n<div class=\"_bdw-2px _bdcl-primary-800\"></div>\n<div class=\"_bdw-2px _bdcl-primary-700\"></div>\n<div class=\"_bdw-2px _bdcl-primary-600\"></div>\n<div class=\"_bdw-2px _bdcl-primary-500\"></div>\n<div class=\"_bdw-2px _bdcl-primary-400\"></div>\n<div class=\"_bdw-2px _bdcl-primary-300\"></div>\n<div class=\"_bdw-2px _bdcl-primary-200\"></div>\n<div class=\"_bdw-2px _bdcl-primary-100\"></div>\n\n<!-- Accent Border Color with Ligthness Modifier -->\n<div class=\"_bdw-2px _bdcl-accent-900\"></div>\n<div class=\"_bdw-2px _bdcl-accent-800\"></div>\n<div class=\"_bdw-2px _bdcl-accent-700\"></div>\n<div class=\"_bdw-2px _bdcl-accent-600\"></div>\n<div class=\"_bdw-2px _bdcl-accent-500\"></div>\n<div class=\"_bdw-2px _bdcl-accent-400\"></div>\n<div class=\"_bdw-2px _bdcl-accent-300\"></div>\n<div class=\"_bdw-2px _bdcl-accent-200\"></div>\n<div class=\"_bdw-2px _bdcl-accent-100\"></div>\n\n<!-- Neutral Border Color with Ligthness Modifier -->\n<div class=\"_bdw-2px _bdcl-neutral-900\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-800\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-700\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-600\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-500\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-400\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-300\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-200\"></div>\n<div class=\"_bdw-2px _bdcl-neutral-100\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary _mgbt-8px"
  }, [_vm._v("_bdcl-primary")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent _mgbt-8px"
  }, [_vm._v("_bdcl-accent")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-positive _mgbt-8px"
  }, [_vm._v("_bdcl-positive")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-negative _mgbt-8px"
  }, [_vm._v("_bdcl-negative")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-warning _mgbt-8px"
  }, [_vm._v("_bdcl-warning")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-info _mgbt-32px"
  }, [_vm._v("_bdcl-info")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-white _mgbt-8px"
  }, [_vm._v("_bdcl-white")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-gray _mgbt-8px"
  }, [_vm._v("_bdcl-gray")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-dark _mgbt-8px"
  }, [_vm._v("_bdcl-dark")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-black _mgbt-32px"
  }, [_vm._v("_bdcl-black")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-900 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-900")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-800 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-800")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-700 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-700")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-600 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-600")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-500 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-500")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-400 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-400")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-300 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-300")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-200 _mgbt-8px"
  }, [_vm._v("_bdcl-primary-200")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary-100 _mgbt-32px"
  }, [_vm._v("_bdcl-primary-100")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-900 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-900")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-800 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-800")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-700 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-700")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-600 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-600")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-500 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-500")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-400 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-400")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-300 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-300")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-200 _mgbt-8px"
  }, [_vm._v("_bdcl-accent-200")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-accent-100 _mgbt-32px"
  }, [_vm._v("_bdcl-accent-100")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-900 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-900")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-800 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-800")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-700 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-700")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-600 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-600")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-500 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-500")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-400")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-300 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-300")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-200 _mgbt-8px"
  }, [_vm._v("_bdcl-neutral-200")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-neutral-100"
  }, [_vm._v("_bdcl-neutral-100")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Border Color และ hover")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Border Color -->\n<div class=\"_bdw-2px _bdcl-primary\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "_wsp-nw _bdw-2px _bdcl-primary _bdcl-negative-hover _mgbt-8px"
  }, [_vm._v("\n          _bdcl-primary _bdcl-negative-hover\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-border-radius"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Border Radius\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdrd-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-radius")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdtlrd-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-top-left-radius")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdtrrd-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-top-right-radius")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdbtlrd-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-bottom-left-radius")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdbtrrd-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("border-bottom-right-radius")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdrd-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdtlrd-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdtrrd-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdbtlrd-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bdbtrrd-*")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-16px"
  }, [_c('strong', [_vm._v("Pixel Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("12px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("24px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("48px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("64px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("128px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("256px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("512px")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px"
  }, [_c('strong', [_vm._v("Percentage Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("50pct")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Biomatic's Color Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("max")]), _vm._v(" (9999px)\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Border Width")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Border Radius -->\n<div class=\"_bdw-2px _bdrd-2px\"></div>\n<div class=\"_bdw-2px _bdrd-4px\"></div>\n<div class=\"_bdw-2px _bdrd-8px\"></div>\n<div class=\"_bdw-2px _bdrd-max\"></div>\n<div class=\"_bdw-2px _bdrd-50pct\"></div>\n\n<div class=\"_bdw-2px _bdtrrd-2px\"></div>\n<div class=\"_bdw-2px _bdtrrd-4px\"></div>\n<div class=\"_bdw-2px _bdtrrd-8px\"></div>\n<div class=\"_bdw-2px _bdtrrd-max\"></div>\n<div class=\"_bdw-2px _bdtrrd-50pct\"></div>\n\n<div class=\"_bdw-2px _bdtrrd-2px _bdbtrrd-2px\"></div>\n<div class=\"_bdw-2px _bdtrrd-4px _bdbtrrd-4px\"></div>\n<div class=\"_bdw-2px _bdtrrd-8px _bdbtrrd-8px\"></div>\n<div class=\"_bdw-2px _bdtrrd-max _bdbtrrd-max\"></div>\n<div class=\"_bdw-2px _bdtrrd-50pct _bdbtrrd-50pct\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdrd-2px _mgbt-8px"
  }, [_vm._v("._bdrd-2px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdrd-4px _mgbt-8px"
  }, [_vm._v("._bdrd-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdrd-8px _mgbt-8px"
  }, [_vm._v("._bdrd-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdrd-max _mgbt-8px"
  }, [_vm._v("._bdrd-max")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdrd-50pct _mgbt-32px"
  }, [_vm._v("._bdrd-50pct")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-2px _mgbt-8px"
  }, [_vm._v("._bdtrrd-2px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-4px _mgbt-8px"
  }, [_vm._v("._bdtrrd-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-8px _mgbt-8px"
  }, [_vm._v("._bdtrrd-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-max _mgbt-8px"
  }, [_vm._v("._bdtrrd-max")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-50pct _mgbt-32px"
  }, [_vm._v("._bdtrrd-50pct")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-2px _bdbtrrd-2px _mgbt-8px"
  }, [_vm._v("._bdtrrd-2px ._bdbtrrd-2px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-4px _bdbtrrd-4px _mgbt-8px"
  }, [_vm._v("._bdtrrd-4px ._bdbtrrd-4px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-8px _bdbtrrd-8px _mgbt-8px"
  }, [_vm._v("._bdtrrd-8px ._bdbtrrd-8px")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-max _bdbtrrd-max _mgbt-8px"
  }, [_vm._v("._bdtrrd-max ._bdbtrrd-max")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _bdw-2px _h-32px _bdcl-neutral-700 _bdtrrd-50pct _bdbtrrd-50pct"
  }, [_vm._v("._bdtrrd-50pct ._bdbtrrd-50pct")])])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Card ใช้สำหรับแสดงผลกลุ่มของ Content ในลักษณะ Card รูปแบบต่างๆ\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentButton'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Button\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentForm'
      }
    }
  }, [_vm._v("\n            Form   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-card"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Card\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -warning _fs-6 _mgbt-64px"
  }, [_c('p', [_c('strong', [_vm._v("ข้อควรระวัง")]), _vm._v(" – Card สร้างโดยใช้ CSS Grid จึง Support เฉพาะ "), _c('a', {
    staticClass: "bio-link -fancy",
    attrs: {
      "href": "https://caniuse.com/#feat=css-grid",
      "target": "_blank"
    }
  }, [_vm._v("Modern Browser")]), _vm._v(" เท่านั้น 😖\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card")]), _vm._v(" "), _c('small', {
    staticClass: "_opct-60"
  }, [_vm._v("(Container)")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-cover")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-title")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-subtitle")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-content")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Style: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-horizontal")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-cover")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-title")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-subtitle")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-content")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-actions")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Style: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-attached")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-push-left")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Basic Card -->\n<div class=\"bio-card\">\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n</div>\n\n<!-- Basic Card with Title / Subtitle -->\n<div class=\"bio-card\">\n  <div class=\"bio-card-title\"><strong>Hello World</strong></div>\n  <div class=\"bio-card-subtitle\">@BioMaRu</div>\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n</div>\n\n<!-- Basic Card with Cover -->\n<div class=\"bio-card\">\n  <img class=\"bio-card-cover\" src=\"https://placeimg.com/640/480/animals\" alt=\"image\">\n  <div class=\"bio-card-title\"><strong>Hello Kitty</strong></div>\n  <div class=\"bio-card-subtitle\">@BioMaRu</div>\n</div>\n\n<div class=\"bio-card\">\n  <img class=\"bio-card-cover\" src=\"https://placeimg.com/640/480/animals\" alt=\"image\">\n  <div class=\"bio-card-title\"><strong>Hello Kitty</strong></div>\n  <div class=\"bio-card-subtitle\">@BioMaRu</div>\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-card _mgbt-16px"
  }, [_c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n            Aenean efficitur sit amet massa fringilla egestas.\n            Nullam condimentum luctus turpis.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card _mgbt-16px"
  }, [_c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello World")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-subtitle"
  }, [_vm._v("@BioMaRu")]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n            Aenean efficitur sit amet massa fringilla egestas.\n            Nullam condimentum luctus turpis.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "lo-12 lo-6-sm -gap-16px"
  }, [_c('div', {
    staticClass: "bio-card _ovf-hd _als-st _mgbt-16px"
  }, [_c('img', {
    staticClass: "bio-card-cover",
    attrs: {
      "src": "https://placeimg.com/360/128/animals",
      "alt": "image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello Kitty")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-subtitle"
  }, [_vm._v("@BioMaRu")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card _ovf-hd  _mgbt-16px"
  }, [_c('img', {
    staticClass: "bio-card-cover",
    attrs: {
      "src": "https://placeimg.com/360/128/animals",
      "alt": "image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello Kitty")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-subtitle"
  }, [_vm._v("@BioMaRu")]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n              Aenean efficitur sit amet massa fringilla egestas.\n              Nullam condimentum luctus turpis.\n            ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Card แบบ ")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-horizontal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-card -horizontal\">\n  <img class=\"bio-card-cover\" src=\"https://placeimg.com/360/360/animals\" alt=\"image\">\n  <div class=\"bio-card-title\"><strong>Hello Kitty</strong></div>\n  <div class=\"bio-card-subtitle\">@BioMaRu</div>\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-card -horizontal"
  }, [_c('img', {
    staticClass: "bio-card-cover",
    attrs: {
      "src": "https://placeimg.com/360/360/animals",
      "alt": "image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello Kitty")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-subtitle"
  }, [_vm._v("@BioMaRu")]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n            Aenean efficitur sit amet massa fringilla egestas.\n            Nullam condimentum luctus turpis.\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Card ที่มี Actions รูบแบบต่างๆ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Basic Actions -->\n<div class=\"bio-card\">\n  <div class=\"bio-card-title\"><strong>Hello Kitty</strong></div>\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n  <div class=\"bio-card-actions\">\n    <a class=\"bio-link _pdh-8px\" href=\"#\">Cancel</a>\n    <a class=\"bio-link _pdh-8px\" href=\"#\">OK</a>\n  </div>\n</div>\n\n<!-- Actions with with -push-left -->\n</div>\n  <div class=\"bio-card\">\n  <div class=\"bio-card-title\"><strong>Hello Kitty</strong></div>\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n  <div class=\"bio-card-actions -push-left\">\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-facebook _fs-5\"></i></a>\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-google _fs-5\"></i></a>\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-twitter _fs-5\"></i></a>\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-instagram _fs-5\"></i></a>\n  </div>\n</div>\n\n<!-- Actions with with -attached -->\n<div class=\"bio-card\">\n  <div class=\"bio-card-title\"><strong>Hello Kitty</strong></div>\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n  <div class=\"bio-card-actions -attached\">\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-facebook _fs-5\"></i></a>\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-google _fs-5\"></i></a>\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-twitter _fs-5\"></i></a>\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-instagram _fs-5\"></i></a>\n  </div>\n</div>\n\n<!-- Actions with with -attached -->\n<div class=\"bio-card\">\n  <div class=\"bio-card-title\"><strong>Hello Kitty</strong></div>\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n  <div class=\"bio-card-actions -attached\">\n    <a class=\"bio-link _pdh-8px\" href=\"#\">Cancel</a>\n    <a class=\"bio-link _pdh-8px\" href=\"#\">OK</a>\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "lo-12 lo-6-sm -gap-16px"
  }, [_c('div', {
    staticClass: "bio-card"
  }, [_c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello Kitty")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n              Aenean efficitur sit amet massa fringilla egestas.\n              Nullam condimentum luctus turpis.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-actions"
  }, [_c('a', {
    staticClass: "bio-link _pdh-8px",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "bio-link _pdh-8px",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("OK")])])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card _als-st"
  }, [_c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello Kitty")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n              Aenean efficitur sit amet massa fringilla egestas.\n              Nullam condimentum luctus turpis.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-actions -push-left"
  }, [_c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook _fs-5"
  })]), _vm._v(" "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-google _fs-5"
  })]), _vm._v(" "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter _fs-5"
  })]), _vm._v(" "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram _fs-5"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card _als-st"
  }, [_c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello Kitty")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n              Aenean efficitur sit amet massa fringilla egestas.\n              Nullam condimentum luctus turpis.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-actions -attached"
  }, [_c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook _fs-5"
  })]), _vm._v(" "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-google _fs-5"
  })]), _vm._v(" "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter _fs-5"
  })]), _vm._v(" "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram _fs-5"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card _als-st"
  }, [_c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello Kitty")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n              Aenean efficitur sit amet massa fringilla egestas.\n              Nullam condimentum luctus turpis.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-actions -attached"
  }, [_c('a', {
    staticClass: "bio-link _pdh-8px",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "bio-link _pdh-8px",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("OK")])])])])])
}]}

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_dp-f _fdrt-r",
    staticStyle: {
      "padding-top": "60px"
    }
  }, [_c('div', {
    staticClass: "_dp-n _dp-b-sm _pst-f _pdh-16px _pdv-32px _bgcl-neutral-100 _w-256px _ovf-at",
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    staticClass: "bio-accordion _mgbt-24px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-getting-start",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'Introduction'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            เกี่ยวกับ Biomatic\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'Installation'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            วิธีติดตั้ง\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'GettingStart'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            การใช้งาน ⭐️\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-24px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-atomic",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicAlignment'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Alignment\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBackground'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Background\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBorder'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Border\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBoxPosition'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Box Position\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBoxSize'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Box Size\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicColor'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Color\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicCursor'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Cursor\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicDisplay'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Display\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicFloat'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Float\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicMargin'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Margin\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicObjectFit'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Object Fit\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicOpacity'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Opacity\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicOverflow'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Overflow\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicPadding'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Padding\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicTypography'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Typography\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicZIndex'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Z-Index\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-24px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-components",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentAccordion'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Accordion\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentBreadcrumb'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Breadcrumb\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentButton'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Button\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentCard'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Card\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentForm'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Form\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentMessage'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Message\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentProgress'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Progress\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentTooltip'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Tooltip\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-layouts",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'LayoutContainer'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Container\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'LayoutResponsiveGrid'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Responsive Grid\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-utilities",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'UtilityAnimation'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Animation\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'UtilityRise'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n            Rise\n          ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "_pdh-16px _pdh-64px-sm _pdv-0px _mgl-0px _mgl-256px-sm _f-1 _ovf-at"
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('router-view', {
    staticStyle: {
      "max-width": "800px"
    }
  })], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "_fs-5",
    attrs: {
      "for": "accordion-getting-start"
    }
  }, [_c('strong', [_vm._v("Getting Start")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-atomic"
    }
  }, [_c('strong', [_vm._v("Atomic")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-components"
    }
  }, [_c('strong', [_vm._v("Components")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-layouts"
    }
  }, [_c('strong', [_vm._v("Layouts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-utilities"
    }
  }, [_c('strong', [_vm._v("Utilities")])])
}]}

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ Size ของ Box Model ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBoxPosition'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Box Position\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicColor'
      }
    }
  }, [_vm._v("\n            Color   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-box-size"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Box Size\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-border-width"
    }
  }, [_vm._v("Width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-border-color"
    }
  }, [_vm._v("Height")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-border-radius"
    }
  }, [_vm._v("Max Width")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_w-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_h-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("height")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mxw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("max-width")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -primary _fs-6 _mgbt-32px"
  }, [_c('p', [_c('strong', [_vm._v("คำแนะนำ")]), _vm._v(" – สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("max-width")]), _vm._v(" นั้น เราตัดสินใจที่จะใช้\n          "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mxw-*")]), _vm._v(" แทนที่จะเป็น "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mw-*")]), _vm._v("\n          นั่นก็เราต้องการจะมั่นใจว่าในกรณีที่เราเพิ่ม "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("min-width")]), _vm._v(" Class เข้ามาใน อนาคต\n          จะไม่มี Breaking Change ในส่วนนี้ 🙇\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_w-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_h-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mxw-*")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Pixel Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("12px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("24px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("48px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("64px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("128px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("256px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("512px")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Percentage Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("10pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("20pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("30pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("40pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("50pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("60pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("70pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("80pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("90pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("100pct")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("at")]), _vm._v(" สำหรับ \"auto\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Box Size")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Width -->\n<div class=\"_w-1px\"></div>\n<div class=\"_w-2px\"></div>\n<div class=\"_w-4px\"></div>\n<div class=\"_w-8px\"></div>\n<div class=\"_w-16px\"></div>\n<div class=\"_w-32px\"></div>\n<div class=\"_w-64px\"></div>\n<div class=\"_w-50pct\"></div>\n<div class=\"_w-100pct\"></div>\n\n<!-- Height -->\n<div class=\"_h-1px\"></div>\n<div class=\"_h-2px\"></div>\n<div class=\"_h-4px\"></div>\n<div class=\"_h-8px\"></div>\n<div class=\"_h-16px\"></div>\n<div class=\"_h-32px\"></div>\n<div class=\"_h-64px\"></div>\n<div class=\"_h-50pct\"></div>\n<div class=\"_h-100pct\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-1px"
  }, [_c('small', [_vm._v("._w-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-2px"
  }, [_c('small', [_vm._v("._w-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-4px"
  }, [_c('small', [_vm._v("._w-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-8px"
  }, [_c('small', [_vm._v("._w-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-16px"
  }, [_c('small', [_vm._v("._w-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-32px"
  }, [_c('small', [_vm._v("._w-32px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-64px"
  }, [_c('small', [_vm._v("._w-64px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-50pct"
  }, [_c('small', [_vm._v("._w-50pct")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-100pct"
  }, [_c('small', [_vm._v("._w-100pct")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-1px"
  }, [_c('small', [_vm._v("._h-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-2px"
  }, [_c('small', [_vm._v("._h-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-4px"
  }, [_c('small', [_vm._v("._h-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-8px"
  }, [_c('small', [_vm._v("._h-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-16px"
  }, [_c('small', [_vm._v("._h-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-32px"
  }, [_c('small', [_vm._v("._h-32px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-64px"
  }, [_c('small', [_vm._v("._h-64px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300  _mgbt-4px _h-128px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-50pct"
  }, [_c('small', [_vm._v("._h-50pct")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-100pct"
  }, [_c('small', [_vm._v("._h-100pct")])])])])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-5px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Margin ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicFloat'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Float\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicObjectFit'
      }
    }
  }, [_vm._v("\n            Object Fit   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-margin"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Margin\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Margin")]), _vm._v(" "), _c('li', [_vm._v("• Margin Left")]), _vm._v(" "), _c('li', [_vm._v("• Margin Right")]), _vm._v(" "), _c('li', [_vm._v("• Margin Top")]), _vm._v(" "), _c('li', [_vm._v("• Margin Bottom")]), _vm._v(" "), _c('li', [_vm._v("• Margin Vertical")]), _vm._v(" "), _c('li', [_vm._v("• Margin Horizontal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mg-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgl-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-left")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgr-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-right")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgt-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-top")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgbt-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-bottom")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgv-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-top")]), _vm._v(" และ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-bottom")]), _vm._v(" (Vertical)")]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgh-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-left")]), _vm._v(" และ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-right")]), _vm._v(" (Horizontal)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mg-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgl-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgr-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgt-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgbt-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgv-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgh-*")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Pixel Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("12px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("24px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("48px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("64px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("128px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("256px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("512px")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("at")]), _vm._v(" สำหรับ \"auto\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Margin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Margin -->\n<div class=\"_mg-1px\"></div>\n<div class=\"_mg-2px\"></div>\n<div class=\"_mg-4px\"></div>\n<div class=\"_mg-8px\"></div>\n<div class=\"_mg-16px\"></div>\n\n<!-- Margin Left -->\n<div class=\"_mgl-1px\"></div>\n<div class=\"_mgl-2px\"></div>\n<div class=\"_mgl-4px\"></div>\n<div class=\"_mgl-8px\"></div>\n<div class=\"_mgl-16px\"></div>\n\n<!-- Margin Right -->\n<div class=\"_mgr-1px\"></div>\n<div class=\"_mgr-2px\"></div>\n<div class=\"_mgr-4px\"></div>\n<div class=\"_mgr-8px\"></div>\n<div class=\"_mgr-16px\"></div>\n\n<!-- Margin Vertical -->\n<div class=\"_mgv-1px\"></div>\n<div class=\"_mgv-2px\"></div>\n<div class=\"_mgv-4px\"></div>\n<div class=\"_mgv-8px\"></div>\n<div class=\"_mgv-16px\"></div>\n\n<!-- Margin Horizontal -->\n<div class=\"_mgh-1px\"></div>\n<div class=\"_mgh-2px\"></div>\n<div class=\"_mgh-4px\"></div>\n<div class=\"_mgh-8px\"></div>\n<div class=\"_mgh-16px\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mg-1px"
  }, [_c('small', [_vm._v("_mg-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mg-2px"
  }, [_c('small', [_vm._v("_mg-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mg-4px"
  }, [_c('small', [_vm._v("_mg-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mg-8px"
  }, [_c('small', [_vm._v("_mg-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mg-16px"
  }, [_c('small', [_vm._v("_mg-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgl-1px"
  }, [_c('small', [_vm._v("_mgl-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgl-2px"
  }, [_c('small', [_vm._v("_mgl-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgl-4px"
  }, [_c('small', [_vm._v("_mgl-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgl-8px"
  }, [_c('small', [_vm._v("_mgl-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgl-16px"
  }, [_c('small', [_vm._v("_mgl-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgr-1px"
  }, [_c('small', [_vm._v("_mgr-1px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgr-2px"
  }, [_c('small', [_vm._v("_mgr-2px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgr-4px"
  }, [_c('small', [_vm._v("_mgr-4px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgr-8px"
  }, [_c('small', [_vm._v("_mgr-8px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgr-16px"
  }, [_c('small', [_vm._v("_mgr-16px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgv-1px"
  }, [_c('small', [_vm._v("_mgv-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgv-2px"
  }, [_c('small', [_vm._v("_mgv-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgv-4px"
  }, [_c('small', [_vm._v("_mgv-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgv-8px"
  }, [_c('small', [_vm._v("_mgv-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgv-16px"
  }, [_c('small', [_vm._v("_mgv-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgh-1px"
  }, [_c('small', [_vm._v("_mgh-1px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgh-2px"
  }, [_c('small', [_vm._v("_mgh-2px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgh-4px"
  }, [_c('small', [_vm._v("_mgh-4px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgh-8px"
  }, [_c('small', [_vm._v("_mgh-8px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgh-16px"
  }, [_c('small', [_vm._v("_mgh-16px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])])])
}]}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-banner lo-container"
  }, [_c('div', {
    staticClass: "lo-12 lo-6-sm _h-100pct _pdt-0px-sm"
  }, [_c('div', {
    staticClass: "_als-ct _jtfs-ct _cl-white _tal-ct _tal-l-sm"
  }, [_c('h1', [_vm._v("Biomatic UI")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Introduction'
      }
    }
  }, [_c('div', {
    staticClass: "bio-button -accent u-rise _w-256px _mgbt-8px _dp-ilb _dp-b-sm"
  }, [_c('strong', [_vm._v("เริ่มใช้งาน")])])]), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-4"
  }, [_vm._v("\n        CSS Framework ที่ง่าย และคล่องตัวที่สุด "), _c('br'), _vm._v("\n        สำหรับทุกโปรเจคของคุณ\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('small', [_vm._v("เวอร์ชั่นล่าสุด 0.1.17")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_als-e _jtfs-ct _dp-n _dp-b-sm"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(64),
      "height": "400",
      "alt": "hero-image"
    }
  })])
}]}

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Padding ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicOverflow'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Overflow\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicTypography'
      }
    }
  }, [_vm._v("\n            Typography   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-padding"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Padding\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Padding")]), _vm._v(" "), _c('li', [_vm._v("• Padding Left")]), _vm._v(" "), _c('li', [_vm._v("• Padding Right")]), _vm._v(" "), _c('li', [_vm._v("• Padding Top")]), _vm._v(" "), _c('li', [_vm._v("• Padding Bottom")]), _vm._v(" "), _c('li', [_vm._v("• Padding Vertical")]), _vm._v(" "), _c('li', [_vm._v("• Padding Horizontal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pd-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdl-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-left")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdr-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-right")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdt-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-top")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdbt-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-bottom")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdv-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-top")]), _vm._v(" และ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-bottom")]), _vm._v(" (Vertical)")]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdh-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-left")]), _vm._v(" และ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("padding-right")]), _vm._v(" (Horizontal)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pd-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdl-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdr-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdt-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdbt-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdv-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pdh-*")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Pixel Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("12px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("24px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("48px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("64px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("128px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("256px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("512px")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("at")]), _vm._v(" สำหรับ \"auto\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Padding")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Padding -->\n<div class=\"_pd-2px\"></div>\n<div class=\"_pd-4px\"></div>\n<div class=\"_pd-8px\"></div>\n<div class=\"_pd-16px\"></div>\n\n<!-- Padding Left -->\n<div class=\"_pdl-2px\"></div>\n<div class=\"_pdl-4px\"></div>\n<div class=\"_pdl-8px\"></div>\n<div class=\"_pdl-16px\"></div>\n\n<!-- Padding Right -->\n<div class=\"_pdr-2px\"></div>\n<div class=\"_pdr-4px\"></div>\n<div class=\"_pdr-8px\"></div>\n<div class=\"_pdr-16px\"></div>\n\n<!-- Padding Vertical -->\n<div class=\"_pdv-2px\"></div>\n<div class=\"_pdv-4px\"></div>\n<div class=\"_pdv-8px\"></div>\n<div class=\"_pdv-16px\"></div>\n\n<!-- Padding Horizontal -->\n<div class=\"_pdh-2px\"></div>\n<div class=\"_pdh-4px\"></div>\n<div class=\"_pdh-8px\"></div>\n<div class=\"_pdh-16px\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pd-2px"
  }, [_c('small', [_vm._v("_pd-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pd-4px"
  }, [_c('small', [_vm._v("_pd-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pd-8px"
  }, [_c('small', [_vm._v("_pd-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pd-16px"
  }, [_c('small', [_vm._v("_pd-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdl-2px"
  }, [_c('small', [_vm._v("_pdl-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdl-4px"
  }, [_c('small', [_vm._v("_pdl-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdl-8px"
  }, [_c('small', [_vm._v("_pdl-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdl-16px"
  }, [_c('small', [_vm._v("_pdl-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdr-2px"
  }, [_c('small', [_vm._v("_pdr-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdr-4px"
  }, [_c('small', [_vm._v("_pdr-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdr-8px"
  }, [_c('small', [_vm._v("_pdr-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdr-16px"
  }, [_c('small', [_vm._v("_pdr-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdv-2px"
  }, [_c('small', [_vm._v("_pdv-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdv-4px"
  }, [_c('small', [_vm._v("_pdv-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdv-8px"
  }, [_c('small', [_vm._v("_pdv-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdv-16px"
  }, [_c('small', [_vm._v("_pdv-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdh-2px"
  }, [_c('small', [_vm._v("_pdh-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdh-4px"
  }, [_c('small', [_vm._v("_pdh-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdh-8px"
  }, [_c('small', [_vm._v("_pdh-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pdh-16px"
  }, [_c('small', [_vm._v("_pdh-16px")])])])])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: {
      '_bgcl-primary drop-shadow': _vm.isColor
    }
  }, [_c('div', {
    staticClass: "lo-container _h-100pct"
  }, [_c('div', {
    staticClass: "_dp-f _jtfct-spbtw _alit-ct"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(66),
      "height": "50",
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_dp-n _dp-f-sm _alit-ct"
  }, [_c('router-link', {
    staticClass: "bio-link -white _pdh-16px _mgr-32px",
    attrs: {
      "to": {
        name: 'Introduction'
      }
    }
  }, [_c('strong', [_vm._v("Document")])]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "_dp-b _dp-n-sm _pst-rlt _w-64px _h-100pct _cs-pt",
    on: {
      "click": _vm.menuToggle
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade-spin",
      "mode": "out-in"
    }
  }, [(!_vm.isMenuOpen) ? _c('div', {
    staticClass: "_dp-f _alit-ct _jtfct-ct _pst-asl _r-0px _t-0px _w-64px _h-100pct"
  }, [_c('i', {
    staticClass: "fa fa-bars _cl-white _fs-4 _w-24px _h-24px _mg-auto _tal-ct"
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-spin",
      "mode": "out-in"
    }
  }, [(_vm.isMenuOpen) ? _c('div', {
    staticClass: "_dp-f _alit-ct _jtfct-ct _pst-asl _r-0px _t-0px _w-64px _h-100pct"
  }, [_c('i', {
    staticClass: "fa fa-close _cl-white _fs-4 _w-24px _h-24px _mg-auto _tal-ct"
  })]) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-in",
      "mode": "out-in"
    }
  }, [(_vm.isMenuOpen) ? _c('div', {
    staticClass: "_pst-asl _l-0px _w-100pct _pdh-4px",
    staticStyle: {
      "top": "56px"
    }
  }, [_c('div', {
    staticClass: "nav-mobile-menu-panel _bgcl-white _bdrd-2px _pd-16px u-rise-1 _ovf-at"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/BioMaRu/biomatic",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa _fs-3 fa-github bio-link -primary"
  }), _vm._v(" "), _c('span', {
    staticClass: "_cl-primary"
  }, [_c('strong', [_vm._v("Github")])])]), _vm._v(" "), _c('hr', {
    staticClass: "_opct-20 _mgbt-16px _mgt-16px"
  }), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-24px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-getting-start",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "_fs-5",
    attrs: {
      "for": "accordion-getting-start"
    }
  }, [_c('strong', [_vm._v("Getting Start")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'Introduction'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  เกี่ยวกับ Biomatic\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'Installation'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  วิธีติดตั้ง\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'GettingStart'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  การใช้งาน ⭐️\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-24px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-atomic",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-atomic"
    }
  }, [_c('strong', [_vm._v("Atomic")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicAlignment'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Alignment\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBackground'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Background\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBorder'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Border\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBoxPosition'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Box Position\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBoxSize'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Box Size\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicColor'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Color\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicCursor'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Cursor\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicDisplay'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Display\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicFloat'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Float\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicMargin'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Margin\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicObjectFit'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Object Fit\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicOpacity'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Opacity\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicOverflow'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Overflow\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicPadding'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Padding\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicTypography'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Typography\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicZIndex'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Z-Index\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-24px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-components",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-components"
    }
  }, [_c('strong', [_vm._v("Components")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentAccordion'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Accordion\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentBreadcrumb'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Breadcrumb\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentButton'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Button\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentCard'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Card\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentForm'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Form\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentMessage'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Message\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentProgress'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Progress\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentTooltip'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Tooltip\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-layouts",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-layouts"
    }
  }, [_c('strong', [_vm._v("Layouts")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'LayoutContainer'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Container\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'LayoutResponsiveGrid'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Responsive Grid\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-utilities",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-utilities"
    }
  }, [_c('strong', [_vm._v("Utilities")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'UtilityAnimation'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Animation\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'UtilityRise'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Rise\n                ")])], 1)])])]) : _vm._e()])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/BioMaRu/biomatic",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa _fs-3 fa-github bio-link -white"
  })])
}]}

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n        Breadcrumb ใช้สำหรับแสดงโครงสร้างการ Navigation ในหน้าปัจจุบัน\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentAccordion'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Accordion\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentButton'
      }
    }
  }, [_vm._v("\n            Button   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-breadcrumb"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Breadcrumb\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        เราแนะนำให้คุณ ใช้ Class นี้บน "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("<ul>")]), _vm._v(" และ ใช้ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("<li>")]), _vm._v("\n        เป็น List ของ Breadcrumb เพื่อความเหมาะสม\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-breadcrumb")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-breadcrumb")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Breadcrumb")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<ul class=\"bio-breadcrumb\">\n  <li>Home</li>\n  <li>item</li>\n</ul>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('ul', {
    staticClass: "bio-breadcrumb"
  }, [_c('li', [_vm._v("Home")]), _vm._v(" "), _c('li', [_vm._v("Item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งานร่วมกับ")]), _vm._v(" "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v(".bio-link")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<ul class=\"bio-breadcrumb\">\n  <li><a class=\"bio-link\" href=\"#\">Home</a></li>\n  <li><a class=\"bio-link -primary\" href=\"#\">Category</a></li>\n  <li><a class=\"bio-link -primary -fancy\" href=\"#\">Category</a></li>\n  <li><a class=\"bio-link -positive\" href=\"#\">Category</a></li>\n  <li><a class=\"bio-link -positive -fancy\" href=\"#\">Category</a></li>\n  <li><a class=\"bio-link -negative\" href=\"#\">Category</a></li>\n  <li>item</li>\n</ul>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('ul', {
    staticClass: "bio-breadcrumb"
  }, [_c('li', [_c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Category")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "bio-link -primary -fancy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Category")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "bio-link -positive",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Category")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "bio-link -positive -fancy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Category")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "bio-link -negative",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Category")])]), _vm._v(" "), _c('li', [_vm._v("item")])])])
}]}

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n        Progress ใช้สำหรับแสดงปริมาณการกำเนินการ\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentMessage'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Message\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentTooltip'
      }
    }
  }, [_vm._v("\n            Tooltip   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-progress"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Progress\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Progress ใช้งาน Class "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-progress")]), _vm._v("\n        บน Element "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("<progress>")]), _vm._v(" เพียงอย่างเดียว\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-progress")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Color: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-primary")]), _vm._v(" (default),\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-accent")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-positive")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-negative")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-warning")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-info")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-dark")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-black")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Progress -->\n<progress class=\"bio-progress -primary\" value=\"10\" max=\"100\"></progress>\n<progress class=\"bio-progress -accent\" value=\"20\" max=\"100\"></progress>\n<progress class=\"bio-progress -positive\" value=\"30\" max=\"100\"></progress>\n<progress class=\"bio-progress -negative\" value=\"40\" max=\"100\"></progress>\n<progress class=\"bio-progress -warning\" value=\"50\" max=\"100\"></progress>\n<progress class=\"bio-progress -info\" value=\"60\" max=\"100\"></progress>\n<progress class=\"bio-progress -dark\" value=\"70\" max=\"100\"></progress>\n<progress class=\"bio-progress -black\" value=\"80\" max=\"100\"></progress>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('progress', {
    staticClass: "bio-progress -primary _mgbt-8px",
    attrs: {
      "value": "10",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress -accent _mgbt-8px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress -positive _mgbt-8px",
    attrs: {
      "value": "30",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress -negative _mgbt-8px",
    attrs: {
      "value": "40",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress -warning _mgbt-8px",
    attrs: {
      "value": "50",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress -info _mgbt-8px",
    attrs: {
      "value": "60",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress -dark _mgbt-8px",
    attrs: {
      "value": "70",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress -black",
    attrs: {
      "value": "80",
      "max": "100"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน รูปแบบอื่น")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<progress class=\"bio-progress _h-1px\" value=\"20\" max=\"100\"></progress>\n<progress class=\"bio-progress _h-2px\" value=\"20\" max=\"100\"></progress>\n<progress class=\"bio-progress _h-4px\" value=\"20\" max=\"100\"></progress>\n<progress class=\"bio-progress _h-8px\" value=\"20\" max=\"100\"></progress>\n<progress class=\"bio-progress _h-16px\" value=\"20\" max=\"100\"></progress>\n<progress class=\"bio-progress _h-32px\" value=\"20\" max=\"100\"></progress>\n<progress class=\"bio-progress _h-64px\" value=\"20\" max=\"100\"></progress>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('progress', {
    staticClass: "bio-progress _mgbt-8px _h-1px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress _mgbt-8px _h-2px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress _mgbt-8px _h-4px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress _mgbt-8px _h-8px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress _mgbt-8px _h-16px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress _mgbt-8px _h-32px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  }), _vm._v(" "), _c('progress', {
    staticClass: "bio-progress _h-64px",
    attrs: {
      "value": "20",
      "max": "100"
    }
  })])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Form จะรวม Class ที่ใช้สำหรับแสดงผล Input รูปแบบต่างๆ\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Field เป็น Container ที่ใช้จัดการ Input Class และ Element ข้างเคียงที่ทำหน้าที่เป็น\n        Label หรือ Description ของ Input ให้แสดงผลสอดคล้องกัน\n      ")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentCard'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Card\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentMessage'
      }
    }
  }, [_vm._v("\n            Message   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-input"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Form\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-field")]), _vm._v(" "), _c('small', {
    staticClass: "_opct-60"
  }, [_vm._v("(Container) (Optional) ")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-input")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-textarea")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-select")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-checkbox")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-radio")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-field")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Color: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-primary")]), _vm._v(" (default),\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-accent")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-positive")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-negative")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-warning")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-info")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("State: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-disabled")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-input")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-textarea")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-select")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Style: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-multiple")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-checkbox")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Style: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-switch")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-radio")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Input ต่างๆ แบบพื้นฐาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Normal Input -->\n<div class=\"bio-input\">\n  <input type=\"text\" placeholder=\"Type Something\">\n</div>\n\n<!-- Normal Textarea -->\n<div class=\"bio-textarea\">\n  <textarea rows=\"3\" placeholder=\"Textarea\"></textarea>\n</div>\n\n<!-- Normal Select -->\n<div class=\"bio-select\">\n  <select>\n    <option disabled>Please Select an Item...</option>\n    <option>Option 1</option>\n    <option>Option 2</option>\n    <option>Option 3</option>\n  </select>\n</div>\n\n<!-- Normal Checkbox -->\n<div class=\"bio-checkbox\">\n  <input id=\"c1\" type=\"checkbox\">\n  <label for=\"c1\">Checkbox</label>\n</div>\n\n<!-- Normal Radio -->\n<div class=\"bio-radio\">\n  <input id=\"r1\" type=\"radio\" name=\"radio-test1\">\n  <label for=\"r1\">Radio 1</label>\n</div>\n<div class=\"bio-radio\">\n  <input id=\"r2\" type=\"radio\" name=\"radio-test1\" checked>\n  <label for=\"r2\">Radio 2</label>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-input _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Type Something"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bio-textarea _mgbt-8px"
  }, [_c('textarea', {
    attrs: {
      "rows": "3",
      "placeholder": "Textarea"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bio-select _mgbt-32px"
  }, [_c('select', [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Please Select an Item...")]), _vm._v(" "), _c('option', [_vm._v("Option 1")]), _vm._v(" "), _c('option', [_vm._v("Option 2")]), _vm._v(" "), _c('option', [_vm._v("Option 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "bio-checkbox _mgbt-32px"
  }, [_c('input', {
    attrs: {
      "id": "c1",
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "c1"
    }
  }, [_vm._v("Checkbox")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-radio _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "r1",
      "type": "radio",
      "name": "radio-test1"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "r1"
    }
  }, [_vm._v("Radio 1")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-radio _jtfs-s _mgbt-16px"
  }, [_c('input', {
    attrs: {
      "id": "r2",
      "type": "radio",
      "name": "radio-test1",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "r2"
    }
  }, [_vm._v("Radio 2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-3"
  }, [_c('strong', [_vm._v("Switch Checkbox")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Checkbox สามารถใส่ Option "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-switch")]), _vm._v("\n        เพื่อเปลี่ยน Style ให้แสดงผลในลักษณะของ Switch ได้\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Switch")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-checkbox -switch\">\n  <input id=\"checkbox2\" type=\"checkbox\">\n  <label for=\"checkbox2\"></label>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-checkbox -switch"
  }, [_c('input', {
    attrs: {
      "id": "checkbox2",
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox2"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-3"
  }, [_c('strong', [_vm._v("Multiple Select")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        สำหรับ Select สามารถใส่ Option "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-multiple")]), _vm._v("\n        เพื่อใส่ Style ให้ Multiple Select ได้\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Multiple Select")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-select -multiple\">\n  <select multiple>\n    <option disabled>Select dropdown</option>\n    <option>Option 1</option>\n    <option>Option 2</option>\n    <option>Option 3</option>\n    <option>Option 4</option>\n  </select>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-select -multiple"
  }, [_c('select', {
    attrs: {
      "multiple": ""
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select dropdown")]), _vm._v(" "), _c('option', [_vm._v("Option 1")]), _vm._v(" "), _c('option', [_vm._v("Option 2")]), _vm._v(" "), _c('option', [_vm._v("Option 3")]), _vm._v(" "), _c('option', [_vm._v("Option 4")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-3"
  }, [_c('strong', [_vm._v("Field")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Field – Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Positive -->\n<div class=\"bio-field -positive\">\n  <label><strong>Name</strong></label>\n  <div class=\"bio-input -positive\">\n    <input type=\"text\" placeholder=\"What's your name again?\" value=\"BioMaRu\">\n  </div>\n  <small>Great!, awesome name!</small>\n</div>\n\n<!-- Info -->\n<div class=\"bio-field -info\">\n  <label><strong>Optional</strong></label>\n  <div class=\"bio-select\">\n    <select>\n      <option disabled>Select dropdown</option>\n      <option>Option 1</option>\n      <option>Option 2</option>\n      <option>Option 3</option>\n    </select>\n  </div>\n  <small>You can leave this field as a blank</small>\n</div>\n\n<!-- Warinig -->\n<div class=\"bio-field -warning\">\n  <label><strong>Age</strong></label>\n  <div class=\"bio-input\">\n    <input type=\"Number\" placeholder=\"Tell me your age\">\n  </div>\n  <small>Shhhhhh!</small>\n</div>\n\n<!-- Negative -->\n<div class=\"bio-field -negative\">\n  <label><strong>Description</strong></label>\n  <div class=\"bio-textarea\">\n    <textarea rows=\"3\" placeholder=\"Tell us about you\"></textarea>\n  </div>\n  <small>Something Wrong!</small>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-field -positive _mgbt-16px"
  }, [_c('label', [_c('strong', [_vm._v("Name")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-input -positive"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "What's your name again?",
      "value": "BioMaRu"
    }
  })]), _vm._v(" "), _c('small', [_vm._v("Great!, awesome name!")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-field -info _mgbt-16px"
  }, [_c('label', [_c('strong', [_vm._v("Optional")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-select"
  }, [_c('select', [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select dropdown")]), _vm._v(" "), _c('option', [_vm._v("Option 1")]), _vm._v(" "), _c('option', [_vm._v("Option 2")]), _vm._v(" "), _c('option', [_vm._v("Option 3")])])]), _vm._v(" "), _c('small', [_vm._v("You can leave this field as a blank")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-field -warning _mgbt-16px"
  }, [_c('label', [_c('strong', [_vm._v("Age")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-input"
  }, [_c('input', {
    attrs: {
      "type": "Number",
      "placeholder": "Tell me your age"
    }
  })]), _vm._v(" "), _c('small', [_vm._v("Shhhhhh!")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-field -negative"
  }, [_c('label', [_c('strong', [_vm._v("Description")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-textarea"
  }, [_c('textarea', {
    attrs: {
      "rows": "3",
      "placeholder": "Tell us about you"
    }
  })]), _vm._v(" "), _c('small', [_vm._v("Something Wrong!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Field – State")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Disabled Input -->\n<div class=\"bio-field -disabled\">\n  <label><strong>Under Construction</strong></label>\n  <div class=\"bio-input\">\n    <input type=\"Number\" placeholder=\"Tell me your age\" disabled>\n  </div>\n  <small>This field is not ready yet</small>\n</div>\n\n<!-- Disabled Checkbox -->\n<div class=\"bio-field -disabled\">\n  <label><strong>Under Construction</strong></label>\n  <div class=\"bio-checkbox\">\n  <input id=\"c2\" type=\"checkbox\" disabled>\n    <label for=\"c2\">Checkbox</label>\n  </div>\n</div>\n\n<!-- Disabled Radio -->\n<div class=\"bio-field -disabled\">\n  <label><strong>Under Construction</strong></label>\n  <div class=\"bio-radio\">\n    <input id=\"r21\" type=\"radio\" name=\"r-test-2\" disabled>\n    <label for=\"r21\">Checkbox</label>\n  </div>\n  <div class=\"bio-radio\">\n    <input id=\"c22\" type=\"radio\" name=\"r-test-2\" disabled>\n    <label for=\"c22\">Checkbox</label>\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-field -disabled _mgbt-32px"
  }, [_c('label', [_c('strong', [_vm._v("Under Construction")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-input"
  }, [_c('input', {
    attrs: {
      "type": "Number",
      "placeholder": "Tell me your age",
      "disabled": ""
    }
  })]), _vm._v(" "), _c('small', [_vm._v("This field is not ready yet")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-field -disabled _mgbt-16px"
  }, [_c('label', [_c('strong', [_vm._v("Under Construction")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-checkbox"
  }, [_c('input', {
    attrs: {
      "id": "c2",
      "type": "checkbox",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "c2"
    }
  }, [_vm._v("Checkbox")])])]), _vm._v(" "), _c('div', {
    staticClass: "bio-field -disabled _mgbt-16px"
  }, [_c('label', [_c('strong', [_vm._v("Under Construction")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-radio _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "r21",
      "type": "radio",
      "name": "r-test-2",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "r21"
    }
  }, [_vm._v("Checkbox")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-radio"
  }, [_c('input', {
    attrs: {
      "id": "c22",
      "type": "radio",
      "name": "r-test-2",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "c22"
    }
  }, [_vm._v("Checkbox")])])])])
}]}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Rise คือ Utility Class ของ ที่ใช้ทำ Box Shadow รูปแบบต่างๆ เหมื่อนกับ Element นั้น ถูกยกใช้ลอยขึ้น\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'UtilityAnimation'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Animation\n          ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#utility-animation"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Rise\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-rise")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-rise-1")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-rise-2")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-rise-3")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-rise-4")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-rise-5")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Option:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-rise")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-rise-1")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-rise-2")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-rise-3")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-rise-4")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-rise-5")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-hover")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน u-rise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"u-rise\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_dp-ilb _w-64px _h-64px _bgcl-primary-300 u-rise"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน u-rise-*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"u-rise-1\"></div>\n<div class=\"u-rise-2\"></div>\n<div class=\"u-rise-3\"></div>\n<div class=\"u-rise-4\"></div>\n<div class=\"u-rise-5\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_dp-ilb _w-64px _h-64px _bgcl-primary-300 u-rise-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-ilb _w-64px _h-64px _bgcl-primary-300 u-rise-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-ilb _w-64px _h-64px _bgcl-primary-300 u-rise-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-ilb _w-64px _h-64px _bgcl-primary-300 u-rise-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-ilb _w-64px _h-64px _bgcl-primary-300 u-rise-5"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน u-rise-*-hover")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"u-rise-5-hover\"></div>\n<div class=\"u-rise-3 u-rise-5-hover\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_dp-ilb _w-64px _h-64px _bgcl-primary-300 u-rise-5-hover"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-ilb _w-64px _h-64px _bgcl-primary-300 u-rise-3 u-rise-5-hover"
  })])
}]}

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Biomatic ใช้ Grid 12 ในการทำ Responsive Grid\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'LayoutContainer'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Container\n          ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#layout-responsive-grid"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Responsive Grid\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-1")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-2")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-3")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-4")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-6")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-12")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-1-11")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-2-10")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-3-9")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-4-5")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-5-7")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-7-5")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-8-4")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-9-3")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-10-2")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-11-1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Breakpoint:")]), _vm._v(" Yes\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Option:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".lo-*")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("All Gutter: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gap-64px")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Vertical Gutter: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gapv-64px")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Horizontal Gutter: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-gaph-64px")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Column Alignment: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-col-center")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-col-start")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-col-end")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-col-stretch")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Row Alignment: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-row-center")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-row-start")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-row-end")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-row-stretch")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Symmetry Grid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Grid 1 -->\n<div class=\"lo-1 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Grid 3 -->\n<div class=\"lo-3 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Grid 6 -->\n<div class=\"lo-6 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-1")]), _vm._v(" "), _c('div', {
    staticClass: "lo-1 -gap-8px _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-3")]), _vm._v(" "), _c('div', {
    staticClass: "lo-3 -gap-8px _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-6")]), _vm._v(" "), _c('div', {
    staticClass: "lo-6 -gap-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Unsymmetry Grid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Grid 8-4 -->\n<div class=\"lo-8-4 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Grid 3-9 -->\n<div class=\"lo-3-9 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Grid 11-1 -->\n<div class=\"lo-11-1 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gap-8px _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-3-9")]), _vm._v(" "), _c('div', {
    staticClass: "lo-3-9 -gap-8px _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-11-1")]), _vm._v(" "), _c('div', {
    staticClass: "lo-11-1 -gap-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการเปลี่ยนขนาด Gutter ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- All Gutter 32px -->\n<div class=\"lo-8-4 -gap-32px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Vertical Gutter 16px, Horizontal Gutter 4px -->\n<div class=\"lo-8-4 -gapv-16px -gaph-4px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4 .-gap-32px")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gap-32px _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4 .-gapv-16px .-gaph-4px")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gapv-16px -gaph-4px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการ Alignment Item ใน Grid ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- ยืด Grid Item ให้เต็ม Cell ในแนวนอน -->\n<div class=\"lo-8-4 -gap-8px -row-stretch\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- วาง Grid Item ที่ปลาย Cell ในแนวนอน -->\n<div class=\"lo-8-4 -gap-8px -row-end\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- วาง Grid Item ที่ต้น Cell ในแนวนอน -->\n<div class=\"lo-8-4 -gap-8px -row-start\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- วาง Grid Item ตรงกลาง Cell ในแนวนอน -->\n<div class=\"lo-8-4 -gap-8px -row-center\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4 .-row-stretch")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gap-8px -row-stretch _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4 .-row-end")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gap-8px -row-end _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4 .-row-start")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gap-8px -row-start _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-8-4 .-row-center")]), _vm._v(" "), _c('div', {
    staticClass: "lo-8-4 -gap-8px -row-center _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการร่วมกับ Responsive Breakpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!--\nGrid 12,\nGrid 6 when Small width,\nGrid 8-5 when Medium whdth\nand\nGrid 2-10 when Large width\n-->\n<div class=\"lo-12 lo-6-sm lo-8-4-md lo-2-10-lg -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_mgbt-4px"
  }, [_vm._v(".lo-12 .lo-6-sm .lo-8-4-md .lo-2-10-lg")]), _vm._v(" "), _c('div', {
    staticClass: "lo-12 lo-6-sm lo-8-4-md lo-2-10-lg -gap-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])])])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Animation คือ Utility Class ของ Animation พื้นฐาน ให้คุณหยิบไปใช้งานได้ง่าย\n        ซึ่งตอนนี้จะยังมีไม่มาก แต่เราจะค่อยๆ ทยอยเพิ่มเติม Animation ที่น่าสนใจเข้ามาเรื่อยๆ 🙇\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'LayoutResponsiveGrid'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Responsive Grid\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'UtilityRise'
      }
    }
  }, [_vm._v("\n            Rise   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#utility-animation"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Animation\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-animation-pulse")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-animation-spin")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Option:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-animation-pulse")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".u-animation-spin")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-hover")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Pulse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"_w-64px _h-64px _bgcl-accent u-animation-pulse\"></div>\n\n<!-- Ativate Animation with Hover -->\n<div class=\"_w-64px _h-64px _bgcl-positive u-animation-pulse-hover\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_dp-ilb _w-64px _h-64px _bgcl-accent u-animation-pulse"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-ilb _w-64px _h-64px _bgcl-positive u-animation-pulse-hover _cl-white"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Spin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"_w-64px _h-64px _bgcl-accent u-animation-spin\"></div>\n\n<!-- Ativate Animation with Hover -->\n<div class=\"_w-64px _h-64px _bgcl-positive u-animation-spin-hover\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_dp-ilb _w-64px _h-64px _bgcl-accent u-animation-spin"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-ilb _w-64px _h-64px _bgcl-positive u-animation-spin-hover"
  })])
}]}

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        Alignment คือ Atomic Class ที่ใช้จัดการ Alignment สำหรับ Flex Layout และ Grid Layout\n        ทั้งในเรื่องของทิศทาง และการจัดวางในแนว Main-Axis (แนวเดียวกับทิศทาง) และ\n        Cross-Asix (แนวขวางกับทิศทาง) ประกอบไปด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-flex-direction"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดทิศทางการจัดวางของ Flex Items\n      ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-flex-wrap"
    }
  }), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดวิธีการ Wrap Flex items ด้านใน\n      ")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-flex"
    }
  }), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดขนาดของตัว Flex item\n      ")]), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-align-items"
    }
  }), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-align-content"
    }
  }), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _vm._m(59), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-align-self"
    }
  }), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _vm._m(62), _vm._v(" "), _vm._m(63), _vm._v(" "), _vm._m(64), _vm._v(" "), _vm._m(65), _vm._v(" "), _vm._m(66), _vm._v(" "), _vm._m(67), _vm._v(" "), _vm._m(68), _vm._v(" "), _vm._m(69), _vm._v(" "), _vm._m(70), _vm._v(" "), _vm._m(71), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'GettingStart'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  การใช้งาน\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBackground'
      }
    }
  }, [_vm._v("\n            Background   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-alignment"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Alignment\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-128px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-flex-direction"
    }
  }, [_vm._v("Flex Direction")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-flex-wrap"
    }
  }, [_vm._v("Flex Wrap")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-flex"
    }
  }, [_vm._v("Flex")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-align-items"
    }
  }, [_vm._v("Align Items")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-align-items"
    }
  }, [_vm._v("Justify Items")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-align-content"
    }
  }, [_vm._v("Align Content")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-align-content"
    }
  }, [_vm._v("Justify Content")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-align-self"
    }
  }, [_vm._v("Align Self")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-align-self"
    }
  }, [_vm._v("Justify Self")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-flex-direction"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Flex Direction\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fdrt-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("flex-direction")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fdrt-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("r")]), _vm._v(" สำหรับ \"row\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("cl")]), _vm._v(" สำหรับ \"column\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Flex Direction")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Flex Direction – Row -->\n<div class=\"_dp-f _fdrt-r\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Flex Direction – Column -->\n<div class=\"_dp-f _fdrt-cl\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', [_vm._v("Row")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-r _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', [_vm._v("Column")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-cl"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-flex-wrap"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Flex Wrap\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("flex-wrap")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -primary _fs-6 _mgbt-32px"
  }, [_c('p', [_c('strong', [_vm._v("คำแนะนำ")]), _vm._v(" – flex-wrap ใช้ Class Name "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fw-*")]), _vm._v(" เช่นเดียวกับ font-weight\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fw-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("nw")]), _vm._v(" สำหรับ \"nowrap\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("w")]), _vm._v(" สำหรับ \"wrap\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("wrv")]), _vm._v(" สำหรับ \"wrap-reverse\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Flex Wrap")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Wrap -->\n<div class=\"_dp-f _fw-w\">\n  <div class=\"_w-50pct\">item 1</div>\n  <div class=\"_w-50pct\">item 2</div>\n  <div class=\"_w-50pct\">item 3</div>\n  <div class=\"_w-50pct\">item 4</div>\n</div>\n\n<!-- No Wrap -->\n<div class=\"_dp-f _fw-nw\">\n  <div class=\"_w-50pct\">item 1</div>\n  <div class=\"_w-50pct\">item 2</div>\n  <div class=\"_w-50pct\">item 3</div>\n  <div class=\"_w-50pct\">item 4</div>\n</div>\n\n<!-- Wrap Reverse -->\n<div class=\"_dp-f _fw-wrv\">\n  <div class=\"_w-50pct\">item 1</div>\n  <div class=\"_w-50pct\">item 2</div>\n  <div class=\"_w-50pct\">item 3</div>\n  <div class=\"_w-50pct\">item 4</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_vm._v("\n        Wrap\n        "), _c('div', {
    staticClass: "_dp-f _fw-w _h-64px _mgbt-32px _bdw-2px _bgcl-neutral-400"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 1")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 2")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 3")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 4")])]), _vm._v("\n        No Wrap\n        "), _c('div', {
    staticClass: "_dp-f _fw-nw _h-64px _mgbt-32px _bdw-2px _bgcl-neutral-400"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 1")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 2")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 3")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 4")])]), _vm._v("\n        Wrap Reverse\n        "), _c('div', {
    staticClass: "_dp-f _fw-wrv _h-64px _mgbt-8px _bdw-2px _bgcl-neutral-400"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 1")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 2")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 3")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 4")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-flex"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Flex\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_f-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("flex")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_f-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("3")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("5")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("6")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("7")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("9")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Flex Wrap")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Flex -->\n<div class=\"_dp-f\">\n  <div class=\"_f-1\">flex 1</div>\n</div>\n\n<div class=\"_dp-f\">\n  <div class=\"_f-1\">flex 1</div>\n  <div class=\"_f-1\">flex 1</div>\n</div>\n\n<div class=\"_dp-f\">\n  <div class=\"_f-1\">flex 1</div>\n  <div class=\"_f-4\">flex 4</div>\n</div>\n\n<div class=\"_dp-f\">\n  <div class=\"_f-1\">flex 1</div>\n  <div class=\"_f-4\">flex 4</div>\n  <div class=\"_f-1\">flex 1</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "_dp-f _h-64px _mgbt-16px _bdw-2px _bgcl-neutral-400"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _f-1 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 1")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _h-64px _mgbt-16px _bdw-2px _bgcl-neutral-400"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _f-1 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 1")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _f-1 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 1")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _h-64px _mgbt-16px _bdw-2px _bgcl-neutral-400"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _f-1 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 1")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _f-4 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 4")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _h-64px _mgbt-8px _bdw-2px _bgcl-neutral-400"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _f-1 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 1")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _f-4 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 4")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _f-1 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-align-items"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Align Items, Justify Items\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Alignment ของ Flex Items ด้านใน Flex Container "), _c('br'), _vm._v("\n        ใช้ Align Items เพื่อจัดในแกน Cross-Axis "), _c('br'), _vm._v("\n        ใช้ Justify Items เพื่อจัดในแกน Main-Axis\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_alit-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("align-items")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_jtfit-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("justify-items")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_alit-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_jtfit-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("st")]), _vm._v(" สำหรับ \"start\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("e")]), _vm._v(" สำหรับ \"end\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("fst")]), _vm._v(" สำหรับ \"flex-start\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("fe")]), _vm._v(" สำหรับ \"flex-end\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("ct")]), _vm._v(" สำหรับ \"center\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("str")]), _vm._v(" สำหรับ \"strecth\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Align Items")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Align Items of Flex Row -->\n<div class=\"_dp-f _alit-ct\">\n  <div>item</div>\n</div>\n<div class=\"_dp-f _alit-fst\">\n  <div>item</div>\n</div>\n<div class=\"_dp-f _alit-fe\">\n  <div>item</div>\n</div>\n<div class=\"_dp-f _alit-str\">\n  <div>item</div>\n</div>\n\n<!-- Align Items of Flex Column -->\n<div class=\"_dp-f _fdrt-cl _alit-ct\">\n  <div>item</div>\n</div>\n<div class=\"_dp-f _fdrt-cl _alit-fst\">\n  <div>item</div>\n</div>\n<div class=\"_dp-f _fdrt-cl _alit-fe\">\n  <div>item</div>\n</div>\n<div class=\"_dp-f _fdrt-cl _alit-str\">\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "_dp-f _h-64px _alit-ct _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _h-64px _alit-fst _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _h-64px _alit-fe _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _h-64px _alit-str _bdw-2px _bdcl-neutral-400 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-cl _h-64px _alit-ct _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-cl _h-64px _alit-fst _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-cl _h-64px _alit-fe _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-cl _h-64px _alit-str _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-align-content"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Align Content, Justify Content\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ การกระจาย Content ด้านใน Container "), _c('br'), _vm._v("\n        ใช้ Align Content เพื่อจัดในแกน Cross-Axis "), _c('br'), _vm._v("\n        ใช้ Justify Content เพื่อจัดในแกน Main-Axis\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_alct-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("align-content")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_jtfct-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("justify-content")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_alct-*")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_jtfct-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("st")]), _vm._v(" สำหรับ \"start\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("e")]), _vm._v(" สำหรับ \"end\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("l")]), _vm._v(" สำหรับ \"left\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("r")]), _vm._v(" สำหรับ \"right\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("fst")]), _vm._v(" สำหรับ \"flex-start\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("fe")]), _vm._v(" สำหรับ \"flex-end\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("str")]), _vm._v(" สำหรับ \"stretch\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("spbtw")]), _vm._v(" สำหรับ \"space-between\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("spar")]), _vm._v(" สำหรับ \"space-around\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("spevl")]), _vm._v(" สำหรับ \"space-evenly\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Justify Content")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Center -->\n<div class=\"_dp-f _jtfct-ct\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Flex Start -->\n<div class=\"_dp-f _jtfct-fst\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Flex End -->\n<div class=\"_dp-f _jtfct-fe\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Space Between -->\n<div class=\"_dp-f _jtfct-spbtw\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Space Around -->\n<div class=\"_dp-f _jtfct-spar\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Space Evenly -->\n<div class=\"_dp-f _jtfct-spevl\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_vm._v("\n        Center\n        "), _c('div', {
    staticClass: "_dp-f _h-64px _jtfct-ct _bdw-2px _bdcl-neutral-400 _mgbt-12px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v("\n        Flex Start\n        "), _c('div', {
    staticClass: "_dp-f _h-64px _jtfct-fst _bdw-2px _bdcl-neutral-400 _mgbt-12px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v("\n        Flex End\n        "), _c('div', {
    staticClass: "_dp-f _h-64px _jtfct-fe _bdw-2px _bdcl-neutral-400 _mgbt-12px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v("\n        Space Between\n        "), _c('div', {
    staticClass: "_dp-f _h-64px _jtfct-spbtw _bdw-2px _bdcl-neutral-400 _mgbt-12px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v("\n        Space Around\n        "), _c('div', {
    staticClass: "_dp-f _h-64px _jtfct-spar _bdw-2px _bdcl-neutral-400 _mgbt-12px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v("\n        Space Evenly\n        "), _c('div', {
    staticClass: "_dp-f _h-64px _jtfct-spevl _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-align-self"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Align Self, Justify Self\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้เพื่อระบุการจัดวางของตัว Flex Item เอง"), _c('br'), _vm._v("\n        ใช้ Align Self เพื่อจัดในแกน Cross-Axis "), _c('br'), _vm._v("\n        ใช้ Justify Self เพื่อจัดในแกน Main-Axis\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_als-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("align-self")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_jtfs-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("justify-self")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_als-*")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_jtfs-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("st")]), _vm._v(" สำหรับ \"start\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("e")]), _vm._v(" สำหรับ \"end\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("l")]), _vm._v(" สำหรับ \"left\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("r")]), _vm._v(" สำหรับ \"right\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("fst")]), _vm._v(" สำหรับ \"flex-start\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("fe")]), _vm._v(" สำหรับ \"flex-end\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("sst")]), _vm._v(" สำหรับ \"self-start\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("se")]), _vm._v(" สำหรับ \"self-end\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("str")]), _vm._v(" สำหรับ \"stretch\" "), _c('br')])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Align Self")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Center -->\n<div class=\"_dp-f\">\n  <div>item 1</div>\n  <div class=\"_als-fst\">item 2</div>\n  <div class=\"_als-ct\">item 3</div>\n  <div class=\"_als-fe\">item 4</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_dp-f _h-64px _bdw-2px _bdcl-neutral-400 _mgbt-12px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 1")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _als-fst _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 2")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _als-ct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 3")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _als-fe _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 4")])])])
}]}

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_bgcl-neutral-800 _pst-rlt _zid-0"
  }, [_c('div', {
    staticClass: "lo-container _cl-white"
  }, [_c('div', {
    staticClass: "_pdv-32px _opct-80"
  }, [_c('div', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Made with  "), _c('i', {
    staticClass: "fa fa-heart _cl-negative u-animation-pulse"
  }), _vm._v("  by BioMaRu")]), _vm._v(" "), _c('div', {
    staticClass: "_opct-50"
  }, [_vm._v("Licensed under the "), _c('a', {
    staticClass: "bio-link -white -fancy",
    attrs: {
      "href": "https://github.com/BioMaRu/biomatic/blob/master/LICENSE"
    }
  }, [_vm._v("MIT License")]), _vm._v(".")])])])])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_vm._v("\n    สวัสดี, ยินดีที่ได้รู้จัก  🎉\n  ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n    Biomatic จะโฟกัสที่ไปที่การใช้ Atomic Class เพื่อสร้างชุดของ Style\n    ที่คุณต้องการเป็นหลัก หรือใช้งานควบคู่ไปกับ Component Class อื่นๆ เพื่อสร้างผลลัพธ์ที่คุณต้องการ\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_vm._v("\n    Biomatic เหมาะสำหรับใคร  🤔\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n    Biomatic เหมาะสำหรับผู้ที่มีความเข้าใจในพื้นฐานเรื่อง CSS หรือ\n    ผู้ที่สนใจเรื่อง Atomic CSS Methodologies เนื่องจาก Biomatic โฟกัสที่ Atomic CSS เป็นหลัก\n    ถ้าคุณมีความเข้าใจในพื้นฐานเรื่อง CSS คุณจะมีความคล่องตัวในการทำงานสูงมาก 🔥\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n    นอกจากนี้ Biomatic ได้จัดเตรียม Components พื้นฐานที่จำเป็นไว้ให้คุณใช้งาน\n    รวมไปถึงเรื่องของการจัดการ Layout ที่ใช้งานได้ง่าย และไม่ซับซ้อน\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_vm._v("\n    ส่วนประกอบของ Biomatic  😍\n  ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n    ปัจจุบัน Biomatic ทำการ Build รวม Class ทั้งหมดไว้เป็น Minified Complied CSS เพียงไฟล์เดียว\n    เพื่อความสะดวกในการติดตั้งและใช้งาน ตัวเลือกอื่นๆ จะถูกเพิ่มเติมในภายหลัง 🙇\n  ")]), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-fe"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'Installation'
      }
    }
  }, [_vm._v("\n        การติดตั้ง   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-6"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-64px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#getting-start"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" เกี่ยวกับ Biomatic\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_c('strong', [_vm._v("Biomatic")]), _vm._v(" เป็น CSS Framework ที่สร้างขึ้นมาโดยคำนึงถึงความยืดหยุ่น\n    และความสะดวกในการใช้งานเป็นหลัก\n    เหมาะสำหรับผู้ที่ต้องการจัดการ User Interface อย่างละเอียด รวดเร็ว และสนุก!\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Biomatic แบ่งออกได้เป็น 4 ส่วน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n        • "), _c('strong', [_vm._v("Atomic Class")]), _vm._v(" – ใช้กำหนด Style ให้ HTML Element และใช้ร่วมกับ Class อื่นๆ"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n        • "), _c('strong', [_vm._v("Component Class")]), _vm._v(" – ใช้แสดงผล Components พื้นฐานต่างๆ เช่น Button, Breadcrumb หรือ Card"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n        • "), _c('strong', [_vm._v("Layout Class")]), _vm._v(" –\n    ใช้จัดการ Responsive Grid, และ Container ต่างๆ\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        • "), _c('strong', [_vm._v("Utility Class")]), _vm._v(" – ใช้เพิ่มพฤติกรรมที่มีความซับซ้อนให้ HTML Element เช่น Animation\n  ")])
}]}

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ การกำหนดรูปแบบการวาง และ ตำแหน่งของ Element ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBorder'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Border\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBoxSize'
      }
    }
  }, [_vm._v("\n            Box Size   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-box-position"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Box Position\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Position")]), _vm._v(" "), _c('li', [_vm._v("• Left")]), _vm._v(" "), _c('li', [_vm._v("• Right")]), _vm._v(" "), _c('li', [_vm._v("• Top")]), _vm._v(" "), _c('li', [_vm._v("• Bottom")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pst-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("position")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_l-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("left")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_r-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("right")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_t-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("top")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bt-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("bottom")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_l-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_r-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_t-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bt-*")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-16px"
  }, [_c('strong', [_vm._v("Pixel Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("12px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("24px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("48px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("64px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("128px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("256px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("512px")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px"
  }, [_c('strong', [_vm._v("Percentage Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("50pct")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("at")]), _vm._v(" สำหรับ \"auto\"\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_pst-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("stt")]), _vm._v(" สำหรับ \"static\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("rlt")]), _vm._v(" สำหรับ \"relative\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("asl")]), _vm._v(" สำหรับ \"absolute\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("f")]), _vm._v(" สำหรับ \"fixed\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Position")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Position -->\n<!-- Left -->\n<div class=\"_pst-rlt _l-1px\"></div>\n<div class=\"_pst-rlt _l-2px\"></div>\n<div class=\"_pst-rlt _l-4px\"></div>\n<div class=\"_pst-rlt _l-8px\"></div>\n<div class=\"_pst-rlt _l-16px\"></div>\n<div class=\"_pst-rlt _l-32px\"></div>\n<div class=\"_pst-rlt _l-64px\"></div>\n\n<!-- Right -->\n<div class=\"_pst-rlt _r-1px\"></div>\n<div class=\"_pst-rlt _r-2px\"></div>\n<div class=\"_pst-rlt _r-4px\"></div>\n<div class=\"_pst-rlt _r-8px\"></div>\n<div class=\"_pst-rlt _r-16px\"></div>\n<div class=\"_pst-rlt _r-32px\"></div>\n<div class=\"_pst-rlt _r-64px\"></div>\n\n<!-- Top -->\n<div class=\"_pst-rlt _t-1px\"></div>\n<div class=\"_pst-rlt _t-2px\"></div>\n<div class=\"_pst-rlt _t-4px\"></div>\n<div class=\"_pst-rlt _t-8px\"></div>\n<div class=\"_pst-rlt _t-16px\"></div>\n\n<!-- Bottom -->\n<div class=\"_pst-rlt _bt-1px\"></div>\n<div class=\"_pst-rlt _bt-2px\"></div>\n<div class=\"_pst-rlt _bt-4px\"></div>\n<div class=\"_pst-rlt _bt-8px\"></div>\n<div class=\"_pst-rlt _bt-16px\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _l-1px"
  }, [_c('small', [_vm._v("._l-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _l-2px"
  }, [_c('small', [_vm._v("._l-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _l-4px"
  }, [_c('small', [_vm._v("._l-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _l-8px"
  }, [_c('small', [_vm._v("._l-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _l-16px"
  }, [_c('small', [_vm._v("._l-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _l-32px"
  }, [_c('small', [_vm._v("._l-32px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _l-64px"
  }, [_c('small', [_vm._v("._l-64px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _r-1px"
  }, [_c('small', [_vm._v("._r-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _r-2px"
  }, [_c('small', [_vm._v("._r-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _r-4px"
  }, [_c('small', [_vm._v("._r-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _r-8px"
  }, [_c('small', [_vm._v("._r-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _r-16px"
  }, [_c('small', [_vm._v("._r-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _r-32px"
  }, [_c('small', [_vm._v("._r-32px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _r-64px"
  }, [_c('small', [_vm._v("._r-64px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _t-1px"
  }, [_c('small', [_vm._v("._t-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _t-2px"
  }, [_c('small', [_vm._v("._t-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _t-4px"
  }, [_c('small', [_vm._v("._t-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _t-8px"
  }, [_c('small', [_vm._v("._t-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-64px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _t-16px"
  }, [_c('small', [_vm._v("._t-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _bt-1px"
  }, [_c('small', [_vm._v("._bt-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _bt-2px"
  }, [_c('small', [_vm._v("._bt-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _bt-4px"
  }, [_c('small', [_vm._v("._bt-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-16px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _bt-8px"
  }, [_c('small', [_vm._v("._bt-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _bt-16px"
  }, [_c('small', [_vm._v("._bt-16px")])])])])
}]}

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-gradient _pdv-32px",
    attrs: {
      "id": "home-getting-start"
    }
  }, [_c('div', {
    staticClass: "lo-container"
  }, [_c('div', {
    attrs: {
      "id": "content"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-white _bdrd-1px u-rise-1 _pdh-8px _pdv-32px _pd-32px-sm"
  }, [_c('HomeGettingStartSetup', {
    staticClass: "_mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_tal-ct _dp-f _jtfct-ct"
  }, [_c('router-link', {
    staticClass: "bio-button -accent _w-256px u-rise",
    attrs: {
      "to": {
        name: 'Introduction'
      }
    }
  }, [_c('strong', [_vm._v("อ่านวิธีใช้งาน")])])], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_tal-ct _mgbt-24px"
  }, [_c('h2', {
    staticClass: "_cl-primary _lh-100pct _mgbt-8px"
  }, [_vm._v("Quick Start")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-5 _opct-60"
  }, [_vm._v("เริ่มต้นกับ Biomatic")])])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-banner"
  }, [_c('div', {
    staticClass: "lo-container"
  }, [_c('div', {
    staticClass: "lo-12-xs lo-4-sm -gap-32px"
  }, [_c('div', {
    staticClass: "_dp-f _fdrt-r _fdrt-cl-sm _alit-ct-sm _jtfct-fst-sm _pst-rlt _mgbt-32px _mgbt-0px-sm"
  }, [_c('img', {
    staticClass: "_w-128px _h-128px _w-256px-sm _mxw-100pct-sm _h-256px-sm _mgr-0px-sm _pst-asl _pst-rlt-sm _opct-20 _opct-100-sm _l-0px _r-0px _mgh-at _mgh-0px-sm",
    attrs: {
      "src": __webpack_require__(62),
      "alt": "atomic"
    }
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "_tal-ct-sm _mgbt-8px"
  }, [_vm._v("ATOMIC")]), _vm._v(" "), _c('p', {
    staticClass: "_tal-l _fs-5 _lh-150pct"
  }, [_vm._v("\n            Atomic Class ที่ยืดหยุ่น และคลอบคลุมการใช้งานตามที่คุณต้องการ\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-r _fdrt-cl-sm _alit-ct-sm _pst-rlt _mgbt-32px _mgbt-0px-sm"
  }, [_c('img', {
    staticClass: "_w-128px _h-128px _w-256px-sm _mxw-100pct-sm _h-256px-sm _mgr-0px-sm _pst-asl _pst-rlt-sm _opct-20 _opct-100-sm _l-0px _r-0px _mgh-at _mgh-0px-sm",
    attrs: {
      "src": __webpack_require__(63),
      "alt": "component"
    }
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "_tal-ct-sm _mgbt-8px"
  }, [_vm._v("COMPONENTS")]), _vm._v(" "), _c('p', {
    staticClass: "_tal-l _fs-5 _lh-150pct"
  }, [_vm._v("\n            มี Components และ Utility พื้นฐานเพื่อให้คุณเริ่มทำงานง่ายขึ้น\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-r _fdrt-cl-sm _alit-ct-sm _pst-rlt _mgbt-32px _mgbt-0px-sm"
  }, [_c('img', {
    staticClass: "_w-128px _h-128px _w-256px-sm _mxw-100pct-sm _h-256px-sm _mgr-0px-sm _pst-asl _pst-rlt-sm _opct-20 _opct-100-sm _l-0px _r-0px _mgh-at _mgh-0px-sm",
    attrs: {
      "src": __webpack_require__(65),
      "alt": "responsive"
    }
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "_tal-ct-sm _mgbt-8px"
  }, [_vm._v("RESPONSIVE")]), _vm._v(" "), _c('p', {
    staticClass: "_tal-l _fs-5 _lh-150pct"
  }, [_vm._v("\n            ระบบ Responsive ที่สะดวก และใช้งานง่าย\n          ")])])])])])])
}]}

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ค่าของ Z-Index เพื่อกำหนดลำดับชั้นการจัดวางในแนวแกน Z-Axis ประกอบไปด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicTypography'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Typography\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentAccordion'
      }
    }
  }, [_vm._v("\n            Accordion   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-z-index"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Z-Index\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Z-Index")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_zid-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("z-index")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_zid-*")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Number Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-1")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("at")]), _vm._v(" สำหรับ \"auto\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -primary _fs-6 _mgbt-32px"
  }, [_c('p', [_c('strong', [_vm._v("คำแนะนำ")]), _vm._v(" – คุณอาจจะแปลกใจว่าทำไมถึง Value จึงมี\n          "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0")]), _vm._v(",\n          "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1")]), _vm._v(",\n          "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-1")]), _vm._v(" และ\n          "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("at")]), _vm._v(" แต่นี้เป็นค่า z-index ที่เพียงพอต่อการใช้งานทุกอย่างแล้ว\n          ถ้าคุณจำเป็นต้องใช้ค่าแปลกๆ เช่น 5, 100, 9999, 2147483647 "), _c('small', [_vm._v("(32-bit Integer)")]), _vm._v(" มันจะต้องมีอะไรผิดพลาดแน่ๆ 😅\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน z-index")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div>1</div>\n<div class=\"_pst-asl\">2</div>\n<div class=\"_pst-asl\">3</div>\n<div class=\"_pst-asl _zid--1\">5</div>\n<div class=\"_pst-asl _zid--1\">4</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _pst-rlt _mgbt-64px"
  }, [_c('div', {
    staticClass: "_w-64px _h-64px _bgcl-neutral-300"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "_pst-asl _w-64px _h-64px _bgcl-neutral-400 _t-24px _l-32px _tal-ct"
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "_pst-asl _w-64px _h-64px _bgcl-neutral-500 _t-32px _tal-ct",
    staticStyle: {
      "left": "80px"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "_pst-asl _w-64px _h-64px _bgcl-neutral-700 _t-16px _zid--1 _tal-r",
    staticStyle: {
      "left": "160px"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('div', {
    staticClass: "_pst-asl _w-64px _h-64px _bgcl-neutral-600 _t-24px _zid--1 _tal-ct",
    staticStyle: {
      "left": "128px"
    }
  }, [_vm._v("4")])])
}]}

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Message ใช้แสดง Content ที่ต้องการดึงความสนใจผู้ใช้และเน้นความรู้สึกต่างๆ\n        เช่น ให้ข้อมูล, แจ้งเตือน, ผิดพลาด เป็นต้น\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentForm'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Form\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentProgress'
      }
    }
  }, [_vm._v("\n            Progress   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-message"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Message\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message")]), _vm._v(" "), _c('small', {
    staticClass: "_opct-60"
  }, [_vm._v("(Container)")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message-content")]), _vm._v(" "), _c('small', {
    staticClass: "_opct-60"
  }, [_vm._v("(optional)")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message-close")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        กรณี Content ที่เป็นเพียง Text คุณไม่จำเป็น\n        ต้องใส่ไว้ด้านใน Element "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message-content")]), _vm._v(" ก็ได้ แต่เมื่อ Content มี Element อื่นๆ แทรกอยู่\n        คุณจำเป็นจะต้องใส่ Content ทั้งหมด ไว้ด้านใน Element "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message-content")]), _vm._v("\n        เพื่อการแสดงผลที่ถูกต้อง\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Color: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-primary")]), _vm._v(" (default),\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-accent")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-positive")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-negative")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-warning")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-info")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-dark")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message-content")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message-close")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Basic Message -->\n<div class=\"bio-message\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n</div>\n\n<!-- Basic Message with Closeable -->\n<div class=\"bio-message\">\n  <div class=\"bio-message-close\">\n    <a class=\"bio-link -fancy\" href=\"#\">close</a>\n  </div>\n  <div class=\"bio-message-content\">\n    <strong>Note – </strong> Lorem ipsum dolor sit amet, <u>consectetur</u> adipiscing elit.\n  </div>\n</div>\n\n<!-- Basic Message with Closeable -->\n<div class=\"bio-message\">\n  <div class=\"bio-message-close\">\n    <a class=\"bio-link u-close\" href=\"#\"></a>\n  </div>\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-message _mgbt-8px"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-message _mgbt-8px"
  }, [_c('div', {
    staticClass: "bio-message-close"
  }, [_c('a', {
    staticClass: "bio-link -fancy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("close")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-message-content"
  }, [_c('strong', [_vm._v("Note – ")]), _vm._v(" Lorem ipsum dolor sit amet, "), _c('u', [_vm._v("consectetur")]), _vm._v(" adipiscing elit.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-message"
  }, [_c('div', {
    staticClass: "bio-message-close"
  }, [_c('a', {
    staticClass: "bio-link u-close",
    attrs: {
      "href": "#"
    }
  })]), _vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน รูปแบบอื่น")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Positive -->\n<div class=\"bio-message -positive\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n</div>\n\n<!-- Negative -->\n<div class=\"bio-message -negative\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n</div>\n\n<!-- Info -->\n<div class=\"bio-message -info\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n</div>\n\n<!-- Warning -->\n<div class=\"bio-message -warning\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n</div>\n\n<!-- Dark -->\n<div class=\"bio-message -dark\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-message -positive _mgbt-8px"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-message -negative _mgbt-8px"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-message -info _mgbt-8px"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-message -warning _mgbt-8px"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-message -dark"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        ")])])
}]}

/***/ })
],[8]);


// WEBPACK FOOTER //
// static/js/app.12476018293a60b80b42.js